// 中文语言包
const messages = {
  // 通用
  common: {
    loading: '加载中...',
    error: '错误',
    success: '成功',
    warning: '警告',
    confirm: '确认',
    cancel: '取消',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    search: '搜索',
    filter: '筛选',
    refresh: '刷新',
    back: '返回',
    next: '下一步',
    submit: '提交',
    reset: '重置',
    close: '关闭',
    more: '更多',
    less: '收起',
    all: '全部',
    none: '无',
    required: '必填',
    optional: '可选',
    unknown: '未知',
    na: 'N/A',
    switchLanguage: '切换语言',
    switchTheme: '切换主题',
    themeSystem: '跟随系统',
    themeLight: '浅色主题',
    themeDark: '深色主题',
  },

  // 导航菜单
  navigation: {
    dashboard: '仪表盘',
    market: '市场',
    backtest: '策略回测',
    strategyComparison: '策略对比',
    strategyRanking: '策略排名',
    experimentRanking: '实验排名',
    analytics: '分析',
    watchlist: '自选列表',
    portfolio: '投资组合',
    parameterOptimization: '参数优化',
    agent: 'AI 代理',
    trade: '交易工作台',
    settings: '配置中心',
    tradeMode: '交易模式',
    paperMode: '模拟',
    realMode: '实盘',
    researchGroup: '研究',
    strategyGroup: '策略',
    tradingGroup: '交易',
    systemGroup: '系统',
    realTradingBanner: '实盘交易模式已启用 - 订单将发送至 Alpaca Markets',
    switchToRealTrading: '切换至实盘交易模式',
    switchToRealMode: '切换至实盘模式',
    stayInPaperMode: '保留模拟模式',
    tradeEnvironment: '交易环境',
    currentEnvironment: '当前环境',
    paperEnvironment: '模拟模式',
    liveEnvironment: '目标环境',
    modeSwitchNoOrder: '切换环境本身不会下单，只会更改后续交易单使用的账户和提交目标。',
    liveOrdersRequireReview: '手动交易单仍需单独检查；已授权的自动执行只会在已配置的风控范围内运行。',
    liveUsesConnectedAccount: '提交后的订单会使用已连接的 Alpaca 实盘账户，并可能影响真实资金。',
    liveRiskAcceptance: '我了解后续提交的订单可能会使用真实资金。',
    realTradingWarning: '实盘交易模式可以使用真实资金下单。',
    realTradingWarningDesc: '订单将发送至 api.alpaca.markets。实盘资金可能面临风险。仅在已配置实盘凭据且了解相关风险时切换。',
    typeRealToConfirm: '请输入“REAL”（全大写）以确认：',
    typeRealPlaceholder: '在此输入 REAL',
    typeRealValidation: '请输入全大写“REAL”以确认。',
    checkConnectionStatus: '在设置中检查连接状态',
    configLabel: '配置',
    settingsLabel: '设置',
    verifyConnections: '检查连接',
  },

  // 仪表板页面
  dashboard: {
    title: '市场仪表盘',
    subtitle: '实时查看量化市场动态与系统状态',
    totalBacktests: '总回测次数',
    activeStrategies: '活跃策略',
    totalProfit: '总收益',
    winRate: '胜率',
    recentBacktests: '最近回测',
    quickActions: '快速操作',
    runBacktest: '运行回测',
    viewHistory: '查看历史',
    compareStrategies: '策略对比',
    noRecentBacktests: '暂无最近回测记录',
    systemStatus: '系统状态',
    cpuUsage: 'CPU 使用率',
    memoryUsage: '内存使用率',
    diskUsage: '磁盘使用率',
    networkStatus: '网络状态',
    marketOverview: '市场概览',
    topGainers: '涨幅榜',
    topLosers: '跌幅榜',
    mostActive: '最活跃',
    refreshData: '刷新数据',
    loading: '加载中...',
    errorLoading: '加载失败',
    backtestId: '回测 ID',
    symbol: '标的',
    strategy: '策略',
    totalReturn: '总收益率',
    status: '状态',
    actions: '操作',
    viewDetails: '查看详情',
    runQuickBacktest: '快速回测',
    addToWatchlist: '加入自选列表',
    removeFromWatchlist: '移出自选列表',
    healthy: '健康',
    warning: '警告',
    critical: '严重',
    online: '在线',
    offline: '离线',
    connected: '已连接',
    disconnected: '未连接',
    lastUpdated: '最后更新',
    totalSymbols: '股票总数',
    gainers: '上涨',
    losers: '下跌',
    avgChange: '平均涨跌幅',
    mktCap: '市值',
    largestMove: '最大波动',
    sectorDistribution: '板块分布',
    marketBreadth: '市场广度',
    advancingVsDeclining: '上涨 vs 下跌',
    overallStatus: '总体状态',
    bullish: '看涨',
    bearish: '看跌',
    neutral: '中性',
    quoteFeed: '报价源',
    brokerConnection: '券商连接',
    symbols: '股票数量',
    environment: '环境',
    noGainersFound: '暂无上涨股票',
    noLosersFound: '暂无下跌股票',
    configureMarketData: '请先配置市场数据 API 以显示此面板。',
    sectorDataUnavailable: '暂无板块数据',
    watchlistSnapshot: '自选快照',
    manageAll: '管理全部',
    watchlistEmpty: '您的自选列表为空。',
    exploreMarket: '探索市场',
    waitingForData: '等待市场数据同步...',
    authRequired: '需要登录',
    authRequiredDesc: '会话已过期，请重新登录以查看市场数据。',
    apiConfigRequired: '需要配置 API',
    apiConfigRequiredDesc: '缺少市场数据 API 密钥，请在设置中配置 Alpaca 或 Finnhub 密钥。',
    configure: '去配置',
    backendConnectionError: '后端连接错误',
    backendConnectionErrorDesc: '无法连接后端服务，请确认后端正在运行。',
    apiError: 'API 错误',
    apiNoPricesDesc: '市场数据 API 未返回价格，请检查 API 密钥配置或速率限制。',
    checkConfig: '检查配置',
    up: '上涨',
    down: '下跌',
    configRequired: '需要配置',
    signIn: '请登录',
    noMarketData: '暂无市场数据',
    marketData: '市场数据',
  },

  // 市场页面
  market: {
    title: '市场概览',
    subtitle: '实时行情与智能操作中心',
    symbol: '标的',
    name: '名称',
    price: '价格',
    change: '涨跌',
    changePercent: '涨跌幅',
    volume: '成交量',
    marketCap: '市值',
    sector: '板块',
    watchlist: '加入自选',
    removeWatchlist: '移出自选',
    searchPlaceholder: '搜索股票代码或公司名称...',
    noResults: '未找到匹配的标的',
    analyze: '分析',
    backtest: '回测',
    search: '搜索',
    allSectors: '全部板块',
    refreshData: '刷新数据',
    dataSyncError: '数据同步错误',
    retry: '重试',
    totalStocks: '股票总数',
    marketGainers: '上涨股票',
    marketLosers: '下跌股票',
    avgChange: '平均涨跌幅',
    dataSource: '数据来源',
    lastSynchronized: '最后同步',
    showing: '显示',
    of: '/',
    assets: '条',
    symbols: '只股票',
    priceHigh: '日内高点',
    priceLow: '日内低点',
    actions: '操作',
    addToWatchlist: '加入自选',
    removeFromWatchlist: '移出自选',
    addToList: '加入列表',
    removeFromList: '从列表移除',
    maxSymbolsReached: '最多 {max} 只股票',
    alreadyInList: '{symbol} 已在列表中',
    addedToList: '已将 {symbol} 加入列表',
    removedFromList: '已将 {symbol} 从列表移除',
    failedToAdd: '添加 {symbol} 失败',
    failedToRemove: '移除 {symbol} 失败',
    authRequired: '需要登录，请重新登录。',
    apiKeysNotConfigured: 'API 密钥未配置，请在设置中配置。',
    searchFailed: '搜索失败',
    alreadyInListShort: '已在列表中',
    noMatchFound: '未找到匹配的公司或代码，请检查输入。',
    addedSymbol: '已添加 {symbol}',
    removedSymbol: '已移除 {symbol}',
    maxSymbolsWarning: '最多 {max} 只股票，请先移除部分再添加。',
    loadingMarketData: '加载市场数据...',
    failedToLoadMarketData: '市场数据加载失败',
    invalidDataFormat: '服务器返回的数据格式不正确',
    noValidStockData: '未获取到有效的股票数据',
  },

  // 回测页面
  backtest: {
    title: '策略回测',
    subtitle: '测试量化策略的历史表现',
    runBacktest: '运行回测',
    backtestHistory: '回测历史',
    parameters: '参数设置',
    symbol: '标的',
    strategy: '策略类型',
    period: '回测周期',
    initialCapital: '初始资金',
    startDate: '开始日期',
    endDate: '结束日期',
    runningBacktest: '回测运行中...',
    backtestCompleted: '回测完成',
    backtestFailed: '回测失败',
    viewDetails: '查看详情',
    compare: '比较',
    deleteBacktest: '删除回测',
    noBacktestHistory: '暂无回测历史',
    selectToCompare: '选择要比较的回测',
    selectedCount: '已选择 {count} 个',
    results: '回测结果',
    tradingChart: '交易图表',
    backToBacktest: '返回回测页面',
    // 表单
    configuration: '回测配置',
    subtitleForm: '用历史价格、交易成本和风险指标检验交易思路。',
    engineReady: '引擎就绪',
    systemNotification: '系统通知',
    stockSymbol: '股票代码 / 组合',
    stockSymbolHelp: '输入股票代码或公司名称',
    stockSymbolPlaceholder: '如 AAPL、MSFT、TSLA',
    stockSymbolRequired: '请输入股票代码',
    strategyModel: '策略模型',
    strategyModelRequired: '请选择策略',
    chooseStrategy: '选择执行策略',
    portfolioActive: '组合模式',
    portfolioMode: '多股票模式：已加载 {count} 只股票用于模拟。',
    executionParams: '执行参数',
    realMarketData: '真实市场数据',
    // 策略参数
    shortMaPeriod: '短均线周期',
    longMaPeriod: '长均线周期',
    rsiPeriod: 'RSI 周期',
    oversold: '超卖',
    overbought: '超买',
    fastEma: '快速 EMA',
    slowEma: '慢速 EMA',
    signal: '信号线',
    periodLabel: '周期',
    stdDev: '标准差',
    momentumPeriod: '动量周期',
    lookbackPeriod: '回望周期',
    entryZScore: '入场 Z 分数',
    exitZScore: '出场 Z 分数',
    stopLossPct: '止损 %',
    takeProfitPct: '止盈 %',
    oversoldLevel: '超卖水平',
    trendMaPeriod: '趋势均线周期',
    trendFilter: '趋势过滤',
    enable: '启用',
    entryPeriod: '入场周期',
    exitPeriod: '出场周期',
    atrPeriod: 'ATR 周期',
    atrStopMultiple: 'ATR 止损',
    emaPeriod: 'EMA 周期',
    atrMultiplier: 'ATR 倍数',
    multiplier: '倍数',
    kPeriod: '%K 周期',
    dPeriod: '%D 周期',
    adxPeriod: 'ADX 周期',
    adxThreshold: 'ADX 阈值',
    fastEmaPeriod: '快 EMA',
    slowEmaPeriod: '慢 EMA',
    // 模拟
    simulationWindow: '模拟窗口',
    initialLiquidity: '初始资金 ($)',
    executingSimulation: '执行模拟中...',
    executeBacktest: '执行回测',
    savePlan: '保存方案',
    hidePlans: '隐藏方案',
    savedPlans: '已保存方案',
    stageForPaper: '模拟交易',
    strategyStaged: '策略已暂存用于模拟交易',
    stageLimited: '暂存功能目前仅支持均线策略',
    // 策略库
    strategyLibrary: '策略库',
    noSavedPlans: '暂无已保存的策略方案。',
    // 最近会话
    recentSessions: '最近会话',
    compareCount: '对比 ({count})',
    noPreviousSessions: '暂无历史会话。',
    quickInsights: '快速洞察',
    exploreTopSymbols: '探索热门标的',
    loadMsftBlueprint: '加载微软蓝图',
    loadTslaBlueprint: '加载特斯拉蓝图',
    msftLoaded: '已加载微软 RSI 会话',
    tslaLoaded: '已加载特斯拉动量会话',
    // 报告
    backtestReport: '回测报告',
    verified: '已验证',
    totalReturnLabel: '总收益',
    sharpeRatioLabel: '夏普比率',
    maxDrawdownLabel: '最大回撤',
    winRateLabel: '胜率',
    totalTrades: '总交易次数',
    netProfit: '净利润',
    // 标签页
    overview: '概览',
    analyticsCharts: '分析图表',
    tradeLog: '交易记录',
    strategyBlueprint: '策略详情',
    // 概览
    strategyModule: '策略模块',
    instrument: '标的',
    initialEquity: '初始权益',
    simulationPeriod: '模拟周期',
    performanceBreakdown: '绩效明细',
    // 结果指标
    strategyLabel: '策略',
    dataMode: '数据模式',
    dataSource: '数据来源',
    statusLabel: '状态',
    annualizedReturn: '年化收益',
    profitLoss: '盈亏',
    calmarRatio: '卡尔马比率',
    avgPnlPerTrade: '平均每笔盈亏',
    sortinoRatio: '索提诺比率',
    avgEquityRatio: '平均权益比率',
    volatility: '波动率',
    profitFactor: '盈利因子',
    expectancy: '期望收益',
    // 结果描述
    descStrategy: '回测使用的策略',
    descDataMode: '回测使用的数据模式',
    descDataSource: '回测数据来源',
    descStatus: '当前回测状态',
    descTotalReturn: '区间总收益',
    descAnnualizedReturn: '年化收益率（CAGR）',
    descProfitLoss: '盈亏金额',
    descSharpeRatio: '年化夏普比率',
    descCalmarRatio: '收益与最大回撤之比',
    descMaxDrawdown: '从峰值开始的最大亏损',
    descWinRate: '盈利交易占比',
    descTrades: '执行的交易总数',
    descAvgPnl: '平均每笔交易盈亏',
    descVolatility: '日波动率',
    descSortinoRatio: '年化索提诺比率',
    descProfitFactor: '总盈利除以总亏损',
    descExpectancy: '每笔交易的期望收益',
    descExposure: '平均权益占初始资金的百分比',
    // 图表
    equityGrowthCurve: '权益增长曲线',
    drawdownAnalysis: '回撤分析',
    detailedTradingSignals: '详细交易信号',
    portfolioNotAvailable: '组合模式下暂无详细价格图表。',
    portfolioValue: '组合价值',
    drawdownLabel: '回撤',
    dateLabel: '日期',
    // 交易记录
    winningTrades: '盈利交易',
    profitFactorLabel: '盈亏比',
    avgProfit: '平均盈利',
    avgLoss: '平均亏损',
    entryDate: '入场日期',
    exitDate: '出场日期',
    action: '操作',
    entryPrice: '入场价',
    exitPrice: '出场价',
    pnlLabel: '盈亏',
    returnPercent: '收益率',
    holdingDays: '持仓天数',
    position: '方向',
    longPosition: '做多',
    shortPosition: '做空',
    noTradeData: '暂无交易数据',
    totalPnl: '总盈亏',
    avgReturn: '平均收益',
    winningTradesCount: '盈利交易',
    losingTradesCount: '亏损交易',
    tradeRange: '第 {start}-{end} 条，共 {total} 笔交易',
    pnlDollar: '盈亏 ($)',
    returnLabel: '收益率',
    // 蓝图
    coreStrategyInfo: '核心策略信息',
    modelName: '模型名称',
    dataProvider: '数据供应商',
    engineVersion: '引擎版本',
    appliedParameters: '应用参数',
    // 策略名称
    strategyMovingAverage: '均线交叉策略',
    strategyRsi: 'RSI 策略',
    strategyMacd: 'MACD 策略',
    strategyBollinger: '布林带策略',
    strategyMomentum: '动量策略',
    strategyMeanReversion: '均值回归策略',
    strategyBuyHold: '买入并持有基准',
    strategyDonchianBreakout: 'Donchian / 海龟突破',
    strategyKeltnerBreakout: 'Keltner 通道突破',
    strategySupertrend: 'SuperTrend 趋势策略',
    strategyStochastic: '随机指标反转',
    strategyAdxTrend: 'ADX 趋势过滤',
    // 历史表格
    select: '选择',
    symbolCol: '代码',
    strategyCol: '策略',
    periodCol: '周期',
    returnCol: '收益',
    sharpeCol: '夏普',
    statusCol: '状态',
    actionsCol: '操作',
    delete: '删除',
    backtestDeleted: '回测已删除',
    backtestDeleteFailed: '删除回测失败',
    loadedBacktest: '已加载回测：{symbol} - {strategy}',
    backtestDataNotFound: '本地存储中未找到回测数据',
    failedToLoadResults: '加载回测结果失败',
    // 状态
    completed: '已完成',
    failed: '失败',
    running: '运行中',
    unknown: '未知',
    realData: '真实数据',
    financialApis: '金融 API',
    // 图表标签（TradingChart 组件）
    priceChartWithSignals: '带交易信号的价格图',
    price: '价格',
    signals: '信号',
    volume: '成交量',
    volumeChart: '成交量图',
    tradingVolumeGreenRed: '交易量 · 绿色=上涨，红色=下跌',
    volumeData: '成交量数据',
    buySignal: '买入信号',
    sellSignal: '卖出信号',
    priceUp: '价格上涨',
    priceDown: '价格下跌',
    // 表单默认值
    defaultLabel: '默认值：{value}',
    // 策略库
    load: '加载',
    symbolLabel: '代码',
    strategyLabelShort: '策略',
    createdLabel: '创建时间',
    // 策略名称映射（蓝图显示）
    strategyNameMovingAverage: '均线策略',
    strategyNameRsi: 'RSI 策略',
    strategyNameMacd: 'MACD 策略',
    strategyNameBollinger: '布林带策略',
    strategyNameMomentum: '动量策略',
    strategyNameMeanReversion: '均值回归策略',
    strategyNameBuyHold: '买入并持有',
    strategyNameDonchianBreakout: 'Donchian 突破',
    strategyNameKeltnerBreakout: 'Keltner 突破',
    strategyNameSupertrend: 'SuperTrend',
    strategyNameStochastic: '随机指标',
    strategyNameAdxTrend: 'ADX 趋势',
    // 参数键映射（蓝图显示）
    paramShortMaPeriod: '短均线周期',
    paramLongMaPeriod: '长均线周期',
    paramRsiPeriod: 'RSI 周期',
    paramRsiOversold: 'RSI 超卖',
    paramRsiOverbought: 'RSI 超买',
    paramMacdFast: 'MACD 快线',
    paramMacdSlow: 'MACD 慢线',
    paramMacdSignal: 'MACD 信号线',
    paramBollingerPeriod: '布林带周期',
    paramBollingerStdDev: '布林带标准差',
    paramMomentumPeriod: '动量周期',
    paramLookbackPeriod: '回望周期',
    paramEntryZScore: '入场 Z 分数',
    paramExitZScore: '出场 Z 分数',
    paramStopLossPct: '止损 %',
    paramTakeProfitPct: '止盈 %',
    paramOversoldLevel: '超卖水平',
    paramTrendMaPeriod: '趋势均线周期',
    paramTrendFilter: '趋势过滤',
    paramEntryPeriod: '入场通道',
    paramExitPeriod: '出场通道',
    paramAtrPeriod: 'ATR 周期',
    paramAtrStopMultiple: 'ATR 止损倍数',
    paramEmaPeriod: 'EMA 周期',
    paramAtrMultiplier: 'ATR 倍数',
    paramMultiplier: '倍数',
    paramKPeriod: '%K 周期',
    paramDPeriod: '%D 周期',
    paramOversold: '超卖',
    paramOverbought: '超买',
    paramAdxPeriod: 'ADX 周期',
    paramAdxThreshold: 'ADX 阈值',
    paramFastEmaPeriod: '快 EMA 周期',
    paramSlowEmaPeriod: '慢 EMA 周期',
    buyHoldDescription: '基准策略：在第一个可用交易日买入并持有到回测窗口结束。',
    // 数据来源显示
    dataBars1Day: '1日K线',
  },

  // 策略比较页面
  comparison: {
    title: 'AlphaLab — 策略对比',
    subtitle: '多策略回测性能对比分析',
    parameterComparison: '参数对比',
    performanceComparison: '性能指标对比',
    equityCurveComparison: '净值曲线对比',
    noBacktestsSelected: '未选择回测进行对比',
    goToBacktestPage: '前往回测页面',
    selectBacktestsPrompt: '请返回回测页面，选择一个或多个回测结果进行对比。',
    loadingBacktestResults: '正在加载回测结果...',
    failedToLoad: '加载失败',
    failedToLoadHistory: '加载回测历史失败',
    failedToLoadResults: '加载回测结果失败',
    backtestId: '回测 ID',
    createdAt: '创建时间',
    status: '状态',
    completed: '已完成',
    running: '运行中',
    failed: '失败',
    parameter: '参数',
    metric: '指标',
    noEquityCurveData: '无可用的净值曲线数据',
    // 选择器页面
    selectSessionsTitle: '选择回测进行对比',
    selectSessionsSubtitle: '从历史记录中选择至少两个已完成的会话，生成分析对比报告。',
    backToBacktest: '返回回测',
    backToComparison: '返回对比',
    refreshHistory: '刷新历史',
    sessionsSelected: '已选择 {count} 个会话',
    selectAtLeast2: '请至少选择 2 个会话进行对比',
    generateComparison: '生成对比（{count}）',
    noHistoryAvailable: '暂无回测历史记录。',
    noHistoryDesc: '请先运行回测，然后返回此页面进行会话对比。',
    goToBacktest: '前往回测',
    // 错误/加载
    dataAnalysisError: '数据分析错误',
    returnToSelection: '返回选择',
    backToSessions: '返回会话',
    initializingEngine: '正在初始化分析引擎...',
    // 状态标签
    statusCompleted: '已完成',
    statusRunning: '运行中',
    statusFailed: '失败',
    // 优胜标签
    bestPosition: '第 {position} 名',
    // 选择器表格列
    colSymbol: '代码',
    colStrategy: '策略',
    colReturn: '收益',
    colSharpe: '夏普',
    colMaxDD: '最大回撤',
    colWinRate: '胜率',
    colDate: '日期',
    // 参数表格标签
    paramSymbol: '代码',
    paramStrategy: '策略',
    paramPeriod: '周期',
    paramInitialCapital: '初始资金',
    paramDataSource: '数据来源',
    paramDataMode: '数据模式',
    paramCreatedAt: '创建时间',
    paramBacktestId: '回测 ID',
    paramStatus: '状态',
    paramStrategyParameters: '策略参数',
    // 指标表格标签
    metricProfitLoss: '盈亏',
    metricTotalReturn: '总收益率',
    metricSharpeRatio: '夏普比率',
    metricMaxDrawdown: '最大回撤',
    metricWinRate: '胜率',
    metricTrades: '交易总数',
    metricAnnualizedReturn: '年化收益率',
    metricSortinoRatio: '索提诺比率',
    metricVolatility: '波动率',
    metricProfitFactor: '盈利因子',
    metricExposure: '持仓占比',
    metricExpectancy: '期望收益',
    metricCalmarRatio: '卡尔马比率',
    metricAvgReturnPerTrade: '平均单笔收益',
    metricBuyHoldReturn: '买入持有收益',
    // 仪表盘
    dashboardTitle: '策略对比仪表盘',
    dashboardSubtitle: '从收益、风险和一致性维度对比选定的回测会话。',
    changeSelection: '更改选择',
    // 汇总卡片
    bestReturn: '最高收益',
    bestSharpe: '最佳夏普',
    lowestDrawdown: '最低回撤',
    highestWinRate: '最高胜率',
    bestProfitFactor: '最佳盈亏比',
    sessionsCount: '会话数',
    // 会话卡片
    sessionPrefix: '会话 {index}',
    returnLabel: '收益',
    sharpeLabel: '夏普',
    maxDDLabel: '最大回撤',
    winRateLabel: '胜率',
    // 图表/区块标题
    sessionRankingTitle: '会话排名与概览',
    performanceMetricsViz: '绩效指标可视化',
    riskRewardQuadrant: '风险/收益象限',
    relativeEquityGrowth: '相对净值增长对比',
    detailedMetricMatrix: '详细指标矩阵与绩效优胜者',
    // 列标题
    performanceMetric: '绩效指标',
    winner: '优胜者',
    noData: '无数据',
    noEquityCurveDetailed: '无可用的净值曲线数据进行详细对比',
    backtestPrefix: '回测 {index}',
    // 策略名称（选择器表格）
    strategyNameMaCross: '均线交叉',
    strategyNameRsiShort: 'RSI',
    strategyNameMacdShort: 'MACD',
    strategyNameBollingerBands: '布林带',
    strategyNameMomentumShort: '动量',
    // 策略名称（排名表格，缩写）
    strategyShortMaCross: '均线',
    strategyShortBb: '布林',
    strategyShortMom: '动量',
    // 图表标签
    chartTotalReturn: '总收益率',
    chartSharpeRatio: '夏普比率',
    chartMaxDrawdown: '最大回撤',
    chartWinRate: '胜率',
    riskLabel: '风险（最大回撤 %）',
    rewardLabel: '收益（收益率 %）',
    strategiesLabel: '策略',
    buyHoldBenchmark: '买入持有基准',
    // 提示消息
    pleaseSelectAtLeast2: '请至少选择 2 个会话进行对比。',
    backtestN: '回测 {index}',
    sessionN: '会话 {index}',
  },

  // 策略排名页面
  ranking: {
    title: 'AlphaLab — 策略排名',
    subtitle: '基于历史回测表现的策略排行榜',
    rank: '排名',
    backtestId: '回测 ID',
    symbol: '标的',
    strategy: '策略',
    totalReturn: '总收益率',
    annualizedReturn: '年化收益率',
    sharpeRatio: '夏普比率',
    maxDrawdown: '最大回撤',
    winRate: '胜率',
    trades: '交易总数',
    avgReturnPerTrade: '平均单笔收益',
    volatility: '波动率',
    sortinoRatio: '索提诺比率',
    profitFactor: '盈利因子',
    expectancy: '期望值',
    exposure: '持仓时间占比',
    noRankingData: '暂无排名数据',
    loadingRanking: '正在加载排名数据...',
    refreshRanking: '刷新排名',
    // 质量标签
    qualityLowSample: '样本不足',
    qualityWeak: '表现较弱',
    qualityHighRisk: '高风险',
    qualityElite: '精英',
    qualityStrong: '强劲',
    qualityStable: '稳健',
    qualityHighReturn: '高收益',
    qualityNeutral: '中性',
    // 表格列
    colRank: '排名',
    colSymbolStrategy: '代码 & 策略',
    colTotalReturn: '总收益率',
    colSharpe: '夏普',
    colMaxDD: '最大回撤',
    colWinRate: '胜率',
    colProfFactor: '盈亏比',
    colTrades: '交易数',
    colDate: '日期',
    colStatus: '状态',
    // 加载
    loadingTip: '正在计算策略排名...',
    // 排行榜
    leaderboardTitle: '策略排行榜',
    leaderboardSubtitle: '基于历史回测表现的策略排名，找到最稳定、最盈利的策略。',
    refreshData: '刷新数据',
    // 汇总卡片
    rankedSessions: '已排名会话',
    bestReturnStat: '最高收益',
    topSharpe: '最佳夏普',
    bestMaxDD: '最优回撤',
    topWinRate: '最高胜率',
    strategiesCount: '策略数',
    // 筛选
    searchPlaceholder: '搜索代码或策略...',
    allStrategies: '全部策略',
    sortByTotalReturn: '总收益率',
    sortBySharpeRatio: '夏普比率',
    sortByMaxDrawdown: '最大回撤',
    sortByWinRate: '胜率',
    sortByProfitFactor: '盈亏比',
    sortByTrades: '交易次数',
    completedOnly: '仅已完成',
    allStatus: '全部状态',
    // 分页
    totalStrategies: '共 {count} 个策略',
    // 空状态
    noRankedStrategies: '暂无已排名策略',
    runBacktestsFirst: '请先运行回测以生成策略排名。',
    goToBacktest: '前往回测',
  },

  // 观察列表页面
  watchlist: {
    title: '自选列表',
    subtitle: '实时监控和分析您关注的标的',
    addSymbol: '添加标的',
    symbolPlaceholder: '如 AAPL、TSLA、NVDA',
    add: '添加',
    remove: '移除',
    noSymbols: '您的自选列表为空',
    addSymbolPrompt: '在上方输入股票代码，开始实时监控和 AI 信号跟踪。',
    addSymbolToWatchlist: '添加标的到自选列表',
    symbolAlreadyExists: '该标的已存在',
    symbolAdded: '标的已添加',
    symbolRemoved: '标的已移除',
    loadingSymbols: '正在加载自选列表...',
    failedToLoad: '加载自选列表失败',
    failedToSave: '保存自选列表失败',
    lastPrice: '最新价',
    dailyChange: '日涨跌',
    marketStatus: '市场状态',
    open: '开盘价',
    high: '最高价',
    low: '最低价',
    prevClose: '前收盘价',
    total: '共',
    symbols: '只标的',
    updated: '更新于',
    avgChange: '平均涨跌幅',
    watchlistSize: '自选数量',
    gainers: '上涨',
    losers: '下跌',
    avgPerformance: '平均表现',
    watchlistItems: '自选标的',
    searchWatchlist: '搜索自选列表...',
    dayRange: '日内区间',
    signal: '信号',
    actions: '操作',
    analyze: '分析',
    backtest: '回测',
    pressEnter: '按回车添加',
    inputHint: '输入公司名称或代码',
    dataUnavailable: '暂无数据',
    tryAAPL: '试试添加 AAPL',
    analyzeTip: '查看技术面分析',
    backtestTip: '回测策略匹配度',
    sortTip: '点击列头排序',
    autoSaveTip: '数据自动保存在浏览器',
    noMatchFound: '未找到匹配的标的 "{input}"',
    alreadyInWatchlist: '{symbol} 已在自选列表中',
    addedToWatchlist: '已将 {symbol} 加入自选列表',
    removedFromWatchlist: '已将 {symbol} 从自选列表移除',
    failedToAdd: '添加 "{input}" 失败，请重试。',
    pleaseEnterSymbol: '请输入股票代码或公司名称',
    clickColumnSort: '点击列头可排序',
  },

  // 参数优化页面
  optimization: {
    title: '参数优化',
    subtitle: '搜索参数范围，找到最优策略配置以实现最佳表现。',
    runOptimization: '运行优化',
    optimizationResults: '优化结果',
    statistics: '统计信息',
    totalCombinations: '总组合数',
    validCombinations: '有效组合数',
    bestReturn: '最高收益率',
    worstReturn: '最低收益率',
    averageReturn: '平均收益率',
    fastMAValues: 'Fast MA 值',
    fastMATooltip: '测试的快速移动平均周期 (如: 5, 10, 20)',
    slowMAValues: 'Slow MA 值',
    slowMATooltip: '测试的慢速移动平均周期 (如: 50, 100, 200)',
    period: '回测周期',
    initialCapital: '初始资金',
    optimizationRunning: '优化运行中...',
    optimizationCompleted: '优化完成',
    optimizationFailed: '优化失败',
    noResults: '暂无优化结果',
    rank: '排名',
    fastMA: 'Fast MA',
    slowMA: 'Slow MA',
    totalReturn: '总收益率',
    annualized: '年化收益率',
    sharpe: '夏普比率',
    maxDD: '最大回撤',
    trades: '交易总数',
    loadingOptimization: '正在加载优化结果...',
    failedToRun: '运行优化失败',
    symbol: '标的',
    strategy: '策略类型',
    topCombination: '最优组合',
    // UI 标签
    optimizationReady: '优化就绪',
    engineConfiguration: '引擎配置',
    stockSymbol: '股票代码',
    strategyModel: '策略模型',
    lookbackPeriod: '回望周期',
    threeMonthsData: '3个月数据',
    sixMonthsData: '6个月数据',
    oneYearData: '1年数据',
    initialLiquidity: '初始资金 ($)',
    parameterSearchSpace: '参数搜索空间',
    runningGeneticSearch: '正在运行遗传搜索...',
    optimizationSuccess: '优化成功',
    configurationError: '配置错误',
    performanceHeatmap: '绩效热力图',
    detailedResultMatrix: '详细结果矩阵',
    start: '起始',
    end: '结束',
    step: '步长',
    // 参数块标题
    shortMaParameters: '短均线参数',
    longMaParameters: '长均线参数',
    momentumPeriodBlock: '动量周期',
    rsiPeriodBlock: 'RSI 周期',
    oversoldLevelBlock: '超卖水平',
    overboughtLevelBlock: '超买水平',
    fastEmaBlock: '快速 EMA',
    slowEmaBlock: '慢速 EMA',
    signalEmaBlock: '信号 EMA',
    periodBlock: '周期参数',
    stdDevBlock: '标准差参数',
    lookbackBlock: '回望周期',
    entryZScoreBlock: '入场 Z 分数',
    exitZScoreBlock: '出场 Z 分数',
    strategyParamFallback: '所选策略 {strategy} 的参数配置将在此显示。',
    // 验证消息
    validationStartEnd: '{field}：起始值（{start}）必须小于或等于结束值（{end}）',
    validationStep: '{field}：步长（{step}）必须大于 0',
    validationShortMaLongMa: '短均线范围应小于长均线范围，以确保有意义的交叉信号',
    validationOversoldOverbought: '超卖水平必须低于超买水平',
    validationFastSlow: '快速 EMA 必须小于慢速 EMA',
    validationStdDev: '标准差必须大于 0',
    // 消息
    optimizationCompletedMsg: '优化完成！找到 {count} 个有效组合。',
    // 策略名称（下拉菜单）
    strategyMovingAverageCrossover: '均线交叉策略',
    strategyRsiStrategy: 'RSI 策略',
    strategyMacdStrategy: 'MACD 策略',
    strategyBollingerBands: '布林带策略',
    strategyMomentumStrategy: '动量策略',
    strategyMeanReversionLabel: '均值回归策略',
    // OptimizationSummary
    summaryTitle: '优化摘要',
    combinations: '组合数',
    validResults: '有效结果',
    bestReturnCard: '最高收益',
    worstReturnCard: '最低收益',
    avgReturn: '平均收益',
    bestSharpeCard: '最佳夏普',
    bestCombinationTitle: '最优组合已识别',
    optimizedBySharpe: '基于夏普比率优化',
    recommended: '推荐',
    paramConfiguration: '参数配置',
    perfMetrics: '绩效指标',
    labelSharpeRatio: '夏普比率',
    labelTotalReturn: '总收益率',
    labelMaxDrawdown: '最大回撤',
    labelWinRate: '胜率',
    // 参数标签
    labelShortMa: '短均线',
    labelLongMa: '长均线',
    labelRsiPeriod: 'RSI 周期',
    labelOversold: '超卖',
    labelOverbought: '超买',
    labelFastMa: '快速均线',
    labelSlowMa: '慢速均线',
    labelSignalMa: '信号均线',
    labelPeriod: '周期',
    labelStdDev: '标准差',
    labelMomentumPeriod: '动量周期',
    // OptimizationHeatmap
    heatmapTitle: '夏普敏感度',
    heatmapLowPerf: '低表现',
    heatmapNeutral: '中性',
    heatmapOptimal: '最优',
    heatmapUnavailable: '可视化不可用',
    heatmapUnavailableDesc: '热力图目前支持二维参数空间（如均线交叉、布林带）。多维参数空间可通过结果矩阵分析。',
    configDetails: '配置详情',
    // OptimizationResultsTable
    colRank: '排名',
    colTotalReturn: '总收益率',
    colSharpe: '夏普',
    colMaxDD: '最大回撤',
    colWinRate: '胜率',
    colTrades: '交易数',
    resultsRange: '{from}-{to} / 共 {total} 条结果',
  },

  // Analytics 页面
  analytics: {
    title: 'AlphaLab — 分析',
    subtitle: '多维度的策略表现与量化性能洞察',
  },

  // 策略类型
  strategies: {
    buy_hold: '买入并持有',
    moving_average: '移动平均',
    rsi: 'RSI 相对强弱',
    macd: 'MACD',
    momentum: '动量策略',
    bollinger: '布林带',
    mean_reversion: '均值回归',
    donchian_breakout: 'Donchian 突破',
    keltner_breakout: 'Keltner 突破',
    supertrend: 'SuperTrend 趋势',
    stochastic: '随机指标反转',
    adx_trend: 'ADX 趋势过滤',
  },

  // 回测周期
  periods: {
    '3m': '3个月',
    '6m': '6个月',
    '1y': '1年',
  },

  // 指标名称
  metrics: {
    totalReturn: '总收益率',
    annualizedReturn: '年化收益率',
    profitLoss: '绝对盈亏',
    sharpeRatio: '夏普比率',
    calmarRatio: '卡尔马比率',
    maxDrawdown: '最大回撤',
    winRate: '胜率',
    trades: '交易总数',
    avgReturnPerTrade: '平均单笔收益',
    volatility: '波动率',
    sortinoRatio: '索提诺比率',
    profitFactor: '盈利因子',
    expectancy: '期望收益',
    exposure: '持仓时间占比',
  },

  // 错误消息
  errors: {
    networkError: '网络错误，请检查您的连接',
    serverError: '服务器错误，请稍后重试',
    invalidSymbol: '无效的标的代码',
    invalidParameter: '参数无效',
    dataFetchError: '获取数据失败',
    optimizationFailed: '参数优化运行失败',
    backtestFailed: '回测执行失败',
    unknownError: '未知系统错误',
  },

  // 成功消息
  successes: {
    backtestStarted: '回测任务已启动',
    backtestCompleted: '回测已完成',
    optimizationStarted: '参数优化任务已启动',
    optimizationCompleted: '参数优化已完成',
    symbolAdded: '标的已加入自选列表',
    symbolRemoved: '标的已从自选列表移除',
    settingsSaved: '配置已成功保存',
  },

  // 警告消息
  warnings: {
    selectBacktestToCompare: '请至少选择一个回测以进行对比',
    noBacktestSelected: '未选择回测任务',
    symbolAlreadyInWatchlist: '该标的已在自选列表中',
    insufficientData: '数据样本不足，无法计算指标',
    highRisk: '高风险警告',
  },

  // 语言切换
  language: {
    english: 'US ENGLISH',
    chinese: 'CN 中文',
    switchLanguage: '切换语言',
    currentLanguage: '当前语言',
  },

  // 首页
  landing: {
    // Navigation
    navHome: '首页',
    navPlatform: '平台',
    navWorkflow: '工作流',
    navFeatures: '特性',
    navTechnology: '技术',
    navSecurity: '安全',
    signIn: '登录',
    getStarted: '开始使用',
    ariaLabelTechPage: '技术页面',
    ariaLabelSwitchLang: '切换语言',
    ariaLabelGetStarted: '开始使用 AlphaLab',
    ariaLabelSignIn: '登录 AlphaLab',

    // Hero 区域
    heroBadge: '研究驱动的量化自动化',
    heroTitle1: 'AI 量化研究，',
    heroTitle2: '系统化验证。',
    heroSubtitle: 'AlphaLab 扫描您配置的市场标的池，用多模型 AI 验证信号，运行回测，生成风控入场计划 — 研究优先的工作流，您始终掌握决策权。',
    startBuilding: '开始构建',
    explorePlatform: '探索平台',

    // Market Field 首页体验
    marketField: {
      navResearch: '研究',
      eyebrow: '让量化研究清晰可见',
      titleLine1: '追踪信号',
      titleLine2: '保留决策权',
      subtitle: '从 8,421 个标的到一份风险受控的计划，每一步都有迹可循。',
      exploreWorkflow: '查看研究流程',
      openPlatform: '进入平台',
      observed: '已观察',
      shortlisted: '已初筛',
      validated: '已验证',
      riskPlan: '风险计划',
      sampleMode: '示例 / 模拟模式',
      momentum: '动量策略',
      walkForwardAnalysis: '滚动样本外验证',
      equityWalkForward: '净值（滚动验证）',
      benchmark: '基准（SPY）',
      walkForward: '滚动验证',
      sharpe: '夏普比率',
      maxDrawdown: '最大回撤',
      hardGatesPassed: '硬性门槛通过',
      riskBudget: '风险预算',
      manualApproval: '人工审批',
      tradePlan: '交易计划（下一阶段）',
      entry: '入场',
      stop: '止损',
      target: '目标',
      evidence: '证据',
      evidenceMomentum: '动量环境',
      evidenceEarnings: '盈利质量',
      evidenceFlow: '资金流与持仓',
      evidenceVolatility: '波动率结构',
      evidenceTechnical: '技术面确认',
      scrollCue: '向下滚动，跟随一个信号',
      storyEyebrow: '一个信号 · 四个研究状态',
      storyTitle: '看着证据逐层汇聚成决策。',
      storySubtitle: '市场全貌始终保留，AlphaLab 每次只增加一层可验证证据。',
      stageObserve: '观察',
      stageObserveShort: '收集数千个信号',
      stageObserveTitle: '把市场当作整体，而不是信息流。',
      stageObserveDesc: '在任何候选进入下一阶段前，同时保留价格、波动率、流动性、相对强度与事件风险。',
      stageFilter: '筛选',
      stageFilterShort: '缩小标的范围',
      stageFilterTitle: '让硬证据缩小候选范围。',
      stageFilterDesc: '在模型审查前，确定性门槛会先剔除流动性不足、结构薄弱或证据不可靠的候选。',
      stageTest: '验证',
      stageTestShort: '执行样本外检验',
      stageTestTitle: '在策略可能失败的地方验证它。',
      stageTestDesc: '滚动样本外验证、交易成本、相对基准收益、回撤与参数稳定性会暴露脆弱策略。',
      stagePlan: '计划',
      stagePlanShort: '构建风控交易计划',
      stagePlanTitle: '把证据转化为边界清晰的计划。',
      stagePlanDesc: '入场、止损、目标、仓位规模与审批状态汇聚在一起，同时保留其背后的假设。',
      candidates: '候选标的',
      liquidityGate: '流动性门槛',
      structureGate: '结构门槛',
      evidenceGate: '证据可靠度',
      passed: '通过',
      review: '复核',
      blocked: '已拦截',
      candidateCount: '8,421 中的 24 个',
      validationCount: '24 中的 3 个',
      awaitingApproval: '等待人工审批',
      paperReady: '模拟模式已就绪',
      researchProof: '展示过程的量化研究',
      researchProofTitle: '每个结果都保留完整证据。',
      researchProofDesc: '从研究到订单，扫描因子、滚动验证、交易成本、风控门槛与执行控制始终可审计。',
      ctaTitle: '跟随下一个想法走完整个流程。',
      ctaDesc: '从模拟模式开始，检查每一道门槛，再决定计划何时可以执行。',
      ctaPrimary: '开始构建',
      ctaSecondary: '查看工作流',
    },

    // 模拟面板
    orchestrator: 'AI 代理编排器',
    globalMarketScan: '市场扫描',
    complete: '已完成',
    processedEquities: '已处理 8,432 只股票，覆盖 14 个因子。',
    deeperValidation: '深度验证',
    analyzing: '分析中',
    llmReview: 'AI 正在审查多周期背离结构。',
    backtestEntryPlan: '回测与入场计划',
    synthesizingStrategy: '正在合成策略',
    riskProtocol: '风险协议',
    strictPerTrade: '严格控制（每笔交易 1%）',
    targetRR: '目标风险回报比',

    // 项目概述
    overviewTitle: '从市场扫描到风控执行',
    overviewDesc: 'AlphaLab 将自动化市场扫描、多模型 AI 信号验证、历史回测和风控入场计划整合到单一系统化量化工作流中。每个交易想法都经过结构化验证流程 — AI 提供辅助，最终决策由您做出。',

    // 技术栈
    builtWith: '技术栈',

    // 核心功能
    capabilitiesTitle: '核心功能',
    capabilitiesSubtitle: '完整的量化工作流 — 扫描、验证、回测、计划、执行。',
    capMarketScanning: '自动化市场扫描',
    capMarketScanningDesc: '跨多个时间周期和技术因子扫描数千只股票，筛选候选标的，而非噪音。',
    capAIValidation: '多模型 AI 验证',
    capAIValidationDesc: '专用模型审查结构、动能和多周期共振。通过交叉验证提升置信度。',
    capBacktesting: '历史回测',
    capBacktestingDesc: '基于多年市场数据验证策略假设。在投入资金前理解策略优势。',
    capEntryPlanning: '入场计划生成',
    capEntryPlanningDesc: '根据您的风险参数，自动生成入场价、止损位、目标价和仓位规模。',
    capRiskControls: '风控引擎',
    capRiskControlsDesc: '单笔交易敞口限制、回撤保护和组合级监控。风险始终在您定义的边界内。',
    capExecution: '模拟与实盘执行',
    capExecutionDesc: '先在模拟环境中验证。确认后再路由至券商。模拟交易是默认模式。',

    // Feature chips (hero)
    chipScanning: '自动化市场扫描',
    chipAI: '多模型 AI 验证',
    chipRisk: '风控仓位管理',
    chipBacktest: '历史回测验证',

    // Dashboard preview labels
    dashPreviewStatus: '研究引擎运行中',
    dashPreviewRisk: '风控层活跃',
    dashPreviewBuy: '已验证',
    dashPreviewSignal: '信号验证',
    dashPreviewActive: '分析中',
    dashPreviewAiOrchestrator: '研究流水线',
    dashPreviewGlobalScan: '市场扫描',
    dashPreviewDone: '已通过',
    dashPreviewProcessed: '覆盖: 8,421 只股票',
    dashPreviewTopSignals: '信号研究队列',
    dashPreviewMomentum: '动量突破',
    dashPreviewWatch: '观察',
    dashPreviewMeanReversion: '均值回归',
    dashPreviewTrendContinuation: '趋势延续',
    dashPreviewEarningsMomentum: '财报动量',
    dashPreviewEquityCurve: '净值曲线预览',
    dashPreviewYTD: '今年',
    dashPreview1M: '1个月',
    dashPreview1W: '1周',
    dashPreviewWinRate: '胜率',
    dashPreviewMaxDD: '最大回撤',
    dashPreviewRiskExp: '风险敞口',
    dashPreviewRiskLow: '低',
    dashPreviewSharpe: '夏普比率',
    dashPreviewMarketPulse: '研究日志',
    dashPreviewSectorPerf: '信号归档',
    dashPreviewLiveFeed: '最近验证记录',
    dashPreviewAutoRouting: '等待审批',
    dashPreviewConfidence: '置信度',
    dashPreviewStatus2: '回测通过',
    dashPreviewStatus3: '风控检查通过',
    dashPreviewStatus4: '等待审核',

    // Example Output
    exampleOutputTitle: '可执行的智能洞察',
    exampleOutputSubtitle: '看看 AlphaLab 如何将市场扫描转化为具体计划。注意：这仅为示例展示，绝非投资建议。',

    // Trust Bar
    trustEmail: '邮件安全验证',
    trustTurnstile: 'Turnstile 防护',
    trustEncryption: '加密 API 密钥',
    trustPaperFirst: '模拟盘优先工作流',

    // GitHub
    githubTitle: '开源透明',
    githubDesc: '探索代码库，贡献引擎代码，或部署您自己的 AlphaLab 流水线实例。',
    githubButton: 'GitHub 仓库',

    // CTA
    ctaTitle: '建立一套研究流程',
    ctaDesc: '从模拟模式开始，检查每一道门槛，再决定哪些计划可以进入执行。',
    ctaGetStarted: '开始使用',
    ctaSignIn: '登录',

    // 页脚
    footerTagline: '研究驱动的量化自动化：市场扫描、信号验证与风控规划。',
    footerProduct: '产品',
    footerTrust: '政策与安全',
    footerResources: '资源',
    footerPrivacyPolicy: '隐私政策',
    footerTermsOfService: '服务条款',
    footerGithub: 'GitHub',
    footerSecureEnv: '模拟优先研究工作区',
    footerDisclaimer: '免责声明：AlphaLab 仅供研究、教育和决策支持使用，不构成投资建议。过往表现不代表未来结果。实盘交易可能造成重大资金损失。请在做出投资决策前自行研究。',
    footerPrivacy: '隐私与安全声明：本平台可能会处理账户、市场和 AI 提供商配置数据。用户不应在公开仓库中输入或暴露敏感 API 密钥。身份验证、提供商配置或交易集成可能需要个人/账户信息。用户需对自己的决策负责。',
    footerCopyright: '© {year} AlphaLab。量化研究工作台。',
  },

  about: {
    backToHome: '返回首页',
    getStarted: '开始使用',
    title: '什么是 AlphaLab？',
    intro: 'AlphaLab 把市场筛选、验证、风险计划和执行复核放在同一个研究工作台中。模型可以协助检查上下文，确定性门槛与用户审批仍然负责最终把关。',
    workflowTitle: '研究与执行流程',
    workflowScannerTitle: '1. 市场扫描',
    workflowScannerDesc: '使用技术指标和策略匹配，对多个板块的股票进行筛选。',
    workflowContinueTitle: '2. 候选复核',
    workflowContinueDesc: '使用已保存的筛选条件和排序规则，把扫描结果缩小为可复核的候选集。',
    workflowFineTitle: '3. 深度筛选',
    workflowFineDesc: '检查入选标的的流动性、新闻背景、市场结构和风险证据。',
    workflowValidationTitle: '4. 深度验证',
    workflowValidationDesc: '先完成样本外检验、成本检查和稳定性门槛，再决定候选是否可以推进。',
    workflowEntryTitle: '5. 入场计划',
    workflowEntryDesc: '确定性计算入场价格、止损、目标价和仓位大小。',
    workflowWatchlistTitle: '6. 持仓监控',
    workflowWatchlistDesc: '跟踪已批准计划、未完成订单、持仓风险和需要人工复核的变化。',
    tradingModesTitle: '模拟交易与实盘交易',
    tradingModesDesc: 'AlphaLab 支持模拟交易和通过 Alpaca Markets 进行的实盘交易。模拟交易使用真实市场数据，但在模拟环境中执行订单。实盘交易连接 Alpaca 实盘 API 并执行真实订单。',
    apiTitle: 'API 配置',
    apiDesc: '你可以在设置中连接 Alpaca、Finnhub 和受支持的模型提供商。已保存凭证在界面中以遮罩形式显示，并由后端集成使用，不会把原文返回浏览器。',
    riskTitle: '风险控制理念',
    riskDesc: '候选标的从研究进入订单复核时，系统会检查已配置的限制。',
    riskPositionSizing: '根据账户权益和每笔交易风险确定仓位大小',
    riskConcentration: '限制单一仓位的最高集中度',
    riskDailyLoss: '设置每日亏损限制',
    riskAiAssessment: '结合上下文复核与确定性风险门槛',
    riskBacktest: '实盘执行前进行回测验证',
    disclaimerTitle: '免责声明',
    disclaimerDesc: 'AlphaLab 是研究与分析工具，本平台的任何内容均不构成投资建议。过往表现不代表未来结果，股票交易也可能损失本金。做出投资决策前，请自行研究，并在需要时咨询专业投资顾问。AlphaLab 创建者不对使用本平台产生的损失承担责任。',
  },

  // 板块/行业名称映射 (key = API 返回的英文名, value = 中文显示)
  sectors: {
    'Technology': '科技',
    'Semiconductors': '半导体',
    'Banking': '银行业',
    'Automobiles': '汽车',
    'Automobile': '汽车',
    'Auto': '汽车',
    'Financial Services': '金融服务',
    'Financial': '金融',
    'Communications': '通信',
    'Communication': '通信',
    'Communication Services': '通信服务',
    'Media': '媒体',
    'Retail': '零售',
    'Consumer': '消费',
    'Consumer Cyclical': '周期性消费',
    'Consumer Defensive': '防御性消费',
    'Healthcare': '医疗保健',
    'Health': '健康',
    'Medical': '医疗',
    'Energy': '能源',
    'Oil': '石油',
    'Gas': '天然气',
    'Industrials': '工业',
    'Industrial': '工业',
    'Manufacturing': '制造业',
    'Real Estate': '房地产',
    'Estate': '房地产',
    'Utilities': '公用事业',
    'Utility': '公用事业',
    'Materials': '材料',
    'Basic Materials': '基础材料',
    'Material': '材料',
    'Information Technology': '信息技术',
    'Information': '信息',
    'Telecommunications': '电信',
    'Insurance': '保险',
    'Pharmaceuticals': '制药',
    'Biotechnology': '生物技术',
    'Software': '软件',
    'Hardware': '硬件',
    'Internet': '互联网',
    'E-Commerce': '电子商务',
    'Entertainment': '娱乐',
    'Transportation': '交通运输',
    'Logistics': '物流',
    'Construction': '建筑',
    'Agriculture': '农业',
    'Defense': '国防',
    'Aerospace': '航空航天',
    'Aerospace & Defense': '航空航天与国防',
    'Beverages': '饮料',
    'Food': '食品',
    'Services': '服务',
    'Apparel': '服装',
    'Textiles': '纺织',
    'Chemicals': '化工',
    'Metals': '金属',
    'Mining': '矿业',
    'Other': '其他',
    'General': '综合',
    'Stocks': '股票',
  } as Record<string, string>,

  // 股票分析页面
  analysis: {
    priceAnalysis: '价格分析',
    technicalSignalSummary: '技术信号摘要',
    tradeSetupReference: '交易设置参考',
    technicalIndicators: '技术指标',
    companyInsights: '公司信息',
    recentPerformance: '近期表现',
    trendBias: '趋势偏向',
    momentumRSI: '动量 (RSI)',
    rangePosition: '区间位置',
    priceVsSMA20: '价格 vs SMA20',
    priceVsSMA50: '价格 vs SMA50',
    sma20VsSMA50: 'SMA20 vs SMA50',
    volumeTrend: '成交量趋势',
    supportResistance: '支撑位 & 阻力位',
    supportLevels: '支撑位',
    resistanceLevels: '阻力位',
    riskManagement: '风险管理',
    entryTarget: '入场目标',
    stopLoss: '止损',
    takeProfit: '止盈',
    riskRewardRatio: '风险/收益比',
    excellentSetup: '优秀设置',
    goodSetup: '良好设置',
    fairSetup: '一般设置',
    poorSetup: '较差设置',
    movingAverages: '移动平均线',
    relativeStrength: '相对强弱指标 (RSI)',
    analysisInsights: '分析洞察',
    monthReturn: '1个月收益',
    threeMonthReturn: '3个月收益',
    yearToDate: '年初至今',
    strongBullish: '强烈看涨',
    bullish: '看涨',
    strongBearish: '强烈看跌',
    bearish: '看跌',
    neutral: '中性',
    overbought: '超买',
    oversold: '超卖',
    near52WHigh: '接近52周高点',
    near52WLow: '接近52周低点',
    upperRange: '上区间',
    midRange: '中间区间',
    lowerRange: '下区间',
    dailyChange: '日涨跌',
    periodChange: '期间涨跌',
    lastClose: '最新收盘',
    analyzingData: '分析数据中...',
    noRSIData: '暂无RSI数据',
    insufficientRSI: '数据不足，无法计算RSI (14)',
    marketDataDelayed: '行情数据延迟15分钟',
    dayHigh: '日内最高',
    dayLow: '日内最低',
    prevClose: '前收盘价',
    marketCap: '市值',
    volume: '成交量',
    currentPrice: '当前价格',
    runBacktest: '运行回测',
    refresh: '刷新',
    chartDataUnavailable: '图表数据不可用',
    noHistoricalBars: '未返回历史数据',
    retryLoadingData: '重新加载数据',
    yearHigh: '52周高',
    yearLow: '52周低',
    change: '涨跌',
    analyzing: '分析数据中...',
    trendDescription: '基于价格走势和均线排列，对 {count} 个数据点进行综合趋势判断。',
    rsiDescription: 'RSI（14）用于识别潜在反转区域和趋势强弱。当前 RSI：{value}',
    rangeDescription: '当前价格相对于52周高点（{high}）和52周低点（{low}）的位置。',
    maInsufficient: '数据不足，无法完成均线分析。',
    maAbove20: '价格位于20日均线上方，短期动量看涨。',
    maBelow20: '价格位于20日均线下方，短期偏弱。',
    ma20Above50: '20日均线位于50日均线上方，中期上升趋势确认。',
    sector: '板块',
    industry: '行业',
    peRatio: '市盈率',
    divYield: '股息率',
    dataUpdated: '数据更新：',
    // 时间周期标签
    tf1Day: '1日',
    tf1Week: '1周',
    tf1Month: '1个月',
    tf3Months: '3个月',
    tf1Year: '1年',
  } as Record<string, string>,

  // Watchlist 信号标签
  signals: {
    'Bullish': '看涨',
    'Bearish': '看跌',
    'Oversold': '超卖',
    'Near support': '接近支撑位',
    'Near resistance': '接近阻力位',
    'No clear setup': '无明确信号',
    'Mild bullish': '温和看涨',
    'Mild bearish': '温和看跌',
    'Data unavailable': '数据不可用',
  } as Record<string, string>,

  // AI Agent 页面
  agent: {
    // 页面标题
    pageTitle: 'AI 代理',
    pageSubtitle: '自主智能市场筛选、技术验证与自动化交易。',
    systemOnline: '系统在线',
    // AI 配置条
    aiProvider: 'AI 供应商',
    model: '模型',
    notSet: '未设置',
    aiStatus: 'AI 状态',
    connected: '已连接',
    notTested: '未测试',
    error: '错误',
    notConfigured: '未配置',
    marketData: '市场数据',
    trading: '交易',
    paper: '模拟',
    notLinked: '未关联',
    manageSettings: '管理设置',
    // A. 交易账户模式
    tradingAccountMode: '交易账户模式',
    paperTrading: '模拟交易',
    realTrading: '实盘交易',
    tradingAccountDesc: '用于入场计划的仓位大小和风险检查。',
    tradingAccountDescNote: '（模式切换仅用于规划，此处不会触发真实订单）',
    tradingModeRealHint: '实盘模式：用于入场计划仓位和风险检查。',
    tradingModePaperHint: '模拟模式：使用虚拟资金进行模拟交易。',
    pipelineModeAiDesc: 'AI 模式：全自动运行扫描、入场计划和退出扫描，自动提交买卖订单。',
    pipelineModeHybridDesc: '混合模式：AI 提供建议，需要手动确认。不自动提交订单。',
    pipelineModeManualDesc: '手动模式：手动运行每一步。不自动下单。',
    syncAccountData: '正在同步账户数据...',
    accountType: '账户类型',
    live: '实盘',
    status: '状态',
    cash: '现金',
    buyingPower: '购买力',
    portfolioValue: '组合价值',
    equity: '权益',
    dayPL: '当日盈亏',
    totalPL: '总盈亏',
    positions: '持仓',
    openOrders: '未成交订单',
    noAccountData: '暂无账户数据',
    configureAlpaca: '请在设置中配置 Alpaca API 以启用交易。',
    // A2. 交易偏好
    tradingPreferences: '交易偏好',
    riskProfile: '风险偏好',
    riskProfileDesc: '影响入场决策、仓位大小和止损/目标价位。',
    lowRisk: '低风险',
    mediumRisk: '中风险',
    highRisk: '高风险',
    timeHorizon: '交易周期',
    timeHorizonDesc: '影响趋势关注点、止损宽度和退出时机。',
    shortTerm: '短期',
    midTerm: '中期',
    longTerm: '长期',
    // A3. 杠杆 ETF
    leveragedAlternative: '杠杆替代标的建议',
    leveragedRiskWarning: '波动和亏损风险更高',
    leveragedFractionable: '支持碎股',
    leveragedWholeShares: '仅整股',
    // B. AI 观察列表
    aiWatchlist: 'AI 观察列表',
    watchlist: '观察列表',
    symbol: '股票代码',
    company: '公司',
    price: '价格',
    change: '涨跌',
    score: '评分',
    confidence: '置信度',
    risk: '风险',
    entry: '入场',
    stopLoss: '止损',
    takeProfit: '止盈',
    reason: '原因',
    actions: '操作',
    buy: '买入',
    sell: '卖出',
    modeAI: '全 AI',
    modeHybrid: '混合',
    modeManual: '手动',
    scheduleOff: '关闭',
    schedule15m: '15 分钟',
    schedule30m: '30 分钟',
    schedule1h: '1 小时',
    schedule2h: '2 小时',
    lastRunLabel: '上次运行：',
    nextRunLabel: '下次运行：',
    statusOK: '正常',
    statusFailed: '失败',
    statusStopped: '已停止',
    viewDetails: '查看详情',
    addToWatchlist: '加入观察列表',
    remove: '移除',
    noWatchlistItems: '暂无观察列表项目',
    clearWatchlist: '清空 AI 观察列表',
    clearWatchlistConfirm: '确定要清空所有项目吗？',
    // C. AI 执行
    aiExecution: 'AI 执行',
    executionCandidates: '执行候选',
    executionLog: '执行日志',
    orderPreview: '订单预览',
    submitted: '已提交',
    failed: '失败',
    pending: '待处理',
    filled: '已成交',
    rejected: '已拒绝',
    canceled: '已取消',
    modeUsed: '使用模式',
    endpointUsed: '使用端点',
    riskGate: '风险门控',
    riskBlocked: '风险拦截',
    confirmationRequired: '需要确认',
    configRequired: '需要配置',
    authRequired: '需要登录',
    apiError: 'API 错误',
    noExecutionCandidates: '暂无执行候选',
    manualModeReviewOnly: '手动模式 — 仅审核。不会下任何订单。',
    // D. 市场扫描器
    marketScanner: '市场扫描器',
    runScanner: '运行扫描',
    stop: '停止',
    scanning: '扫描中',
    completed: '已完成',
    progress: '进度',
    candidates: '候选',
    trend: '趋势',
    momentum: '动量',
    volume: '成交量',
    volatility: '波动率',
    newsSentiment: '新闻情绪',
    eventRisk: '事件风险',
    sector: '板块',
    aiReasoning: 'AI 推理',
    dataSource: '数据来源',
    lastUpdated: '最后更新',
    // E. 继续扫描
    preferredContinueScanList: '优选继续扫描列表',
    continueScan: '继续扫描',
    continue: '继续',
    watch: '观察',
    skip: '跳过',
    selectedBy: '选择依据',
    continueCandidate: '继续候选',
    watchToValidate: '观察验证',
    priority: '优先级',
    recommendation: '推荐',
    noContinueCandidates: '暂无继续扫描候选，请先运行市场扫描。',
    scanInterrupted: '扫描因页面刷新而中断，结果已保留。',
    // F. 精细扫描
    fineScan: '精细扫描',
    entryQuality: '入场质量',
    good: '良好',
    extended: '过度延伸',
    waitForPullback: '等待回调',
    chasing: '追高',
    riskLevel: '风险等级',
    backtest: '回测',
    optimization: '优化',
    strategy: '策略',
    quickTest: '快速测试',
    totalReturn: '总收益率',
    sharpeRatio: '夏普比率',
    maxDrawdown: '最大回撤',
    winRate: '胜率',
    profitFactor: '盈利因子',
    tradeCount: '交易次数',
    signalSummary: '信号摘要',
    limitedSample: '样本有限',
    noFineScanCandidates: '暂无合格的精细扫描候选。请先运行精细扫描或调整条件。',
    fineScanComplete: '精细扫描完成：分析了 {count} 个候选',
    fineScanFailed: '精细扫描失败',
    // G. 深度验证
    deeperValidation: '深度验证',
    validation: '验证',
    oneYearBacktest: '1年回测',
    lightOptimization: '轻量优化',
    parameterStability: '参数稳定性',
    stable: '稳定',
    unstable: '不稳定',
    recentPerformance: '近期表现',
    longTermPerformance: '长期表现',
    pass: '通过',
    fail: '未通过',
    validate: '验证',
    validationResult: '验证结果',
    allValidationFailed: '所有验证标的均失败',
    validationPartial: '验证部分成功：{succeeded} 个成功，{failed} 个失败',
    validationCompleted: '深度验证完成，共 {count} 个结果',
    statusValidating: '验证中',
    statusInterrupted: '已中断',
    runValidation: '运行验证',
    dvSourceContinue: '继续',
    dvSourceWatch: '观察→验证',
    dvTrendImproving: '改善中',
    dvTrendConsistent: '一致',
    dvTrendWeakening: '减弱中',
    dvVerdictConfirmed: '已确认',
    dvVerdictRejected: '已拒绝',
    dvVerdictReview: '待审核',
    dvVerdictPass: '通过',
    dvVerdictWatch: '观察',
    recentVsLongTermLabel: '近期 vs 长期',
    verdictReasons: '判定原因',
    limitedSampleWarn: '样本有限：仅 {trades} 笔交易，{combos} 组合已测试。验证置信度降低。',
    noRiskGateData: '无风险门控数据',
    sourceInternalBacktest: '来源：内部回测',
    sourceInternalOptimization: '来源：内部优化',
    qualityLabel: '质量',
    statusLabel: '状态',
    dataLabel: '数据',
    finalValidationComplete: '最终验证完成。未发现关键警报。',
    noLosses: '无亏损',
    stableLabel: '稳定',
    moderateLabel: '中等',
    weakLabel: '较弱',
    testedCombos: '测试组合数',
    validCombos: '有效组合数',
    bestSharpe: '最佳夏普',
    avgReturn: '平均收益',
    medianReturn: '中位收益',
    positiveRatio: '正收益比',
    returnSpread: '收益分布',
    topResults: '最佳结果',
    profitableRatio: '盈利比率',
    stableParams: '稳定参数',
    longReturn: '长期收益',
    recentReturn: '近期收益',
    longSharpe: '长期夏普',
    recentSharpe: '近期夏普',
    longDD: '长期回撤',
    recentDD: '近期回撤',
    // H. 入场计划
    entryPlan: '入场计划',
    entryZone: '入场区间',
    setup: '形态',
    trigger: '触发',
    recommendedAction: '建议操作',
    planDetails: '计划详情',
    noEntryPlans: '暂无入场计划',
    positionSize: '仓位大小',
    invalidation: '失效条件',
    riskReward: '风险/收益',
    tp1: '止盈1',
    tp2: '止盈2',
    // 退出扫描
    exitScan: '持仓与退出',
    noHoldingsToScan: '暂无持仓可扫描。',
    exitScanCompleted: '退出扫描完成：扫描了 {count} 个持仓',
    exitScanFailed: '退出扫描失败',
    // AI 流水线
    aiPipeline: 'AI 流水线',
    runPipeline: '运行手动流水线',
    runAutoPipelineNow: '立即运行自动流水线',
    // 市场自动运行
    marketAutoRun: '市场自动运行',
    marketAutoRunSubtitle: '市场时段内后台定时流水线。',
    backgroundSchedule: '后台定时',
    scheduleHelperText: '仅在美国市场时段运行，09:30–16:00 ET。',
    lastAutoScan: '上次自动扫描',
    nextAutoScan: '下次自动扫描',
    autoStatus: '自动状态',
    pipelineRunning: '流水线运行中',
    pipelineComplete: '流水线完成！',
    pipelineDisabled: 'AI 流水线运行时禁用。',
    scanAlreadyRunning: '扫描正在运行，请先停止再启动 AI 流水线。',
    // 流水线阶段标签
    pipelineStageMarketScanner: '市场扫描',
    pipelineStageContinueScan: '继续扫描',
    pipelineStageFineScan: '精细扫描',
    pipelineStageDeeperValidation: '深度验证',
    pipelineStageEntryPlan: '入场计划',
    pipelineStageExitScan: '退出扫描',
    // 定时状态
    scheduleRunningWait: '流水线运行中 — 下一轮将等待',
    scheduleEvery: '定时：每 ',
    disabled: '已禁用',
    runsToday: '今日运行次数',
    savedConfig: '已保存配置',
    customConfig: '自定义',
    defaultConfig: '默认',
    savedModeDiffers: '已保存模式与当前交易模式不同。请保存定时设置以同步。',
    backgroundAutoRun: '后台自动运行',
    stepLabel: '步骤',
    progressLabel: '进度',
    lastBackgroundScan: '上次后台扫描',
    scannedLabel: '已扫描',
    filteredLabel: '已过滤',
    aiSuccessLabel: 'AI 成功',
    nextAutoRun: '下次自动运行',
    waitingForNextMarketOpen: '等待下次开市',
    stoppedForToday: '今日已停止 — 下次开市时恢复',
    noTradingToday: '今日不交易 — 下一个交易日恢复',
    nextMarketSchedule: '未来 15 天市场日程',
    recentAutoRuns: '最近自动运行',
    noScheduleData: '暂无市场日程数据。',
    // 执行表格列
    time: '时间',
    side: '方向',
    qty: '数量',
    mode: '模式',
    orderId: '订单 ID',
    orderStatus: '状态',
    // 通用
    loading: '加载中...',
    noData: '暂无数据',
    noResults: '暂无结果',
    configureFirst: '请先在设置中配置 API 密钥',
    pleaseSignIn: '请先登录',
    connectionFailed: '连接失败',
    retry: '重试',
    refresh: '刷新',
    save: '保存',
    cancel: '取消',
    confirm: '确认',
    close: '关闭',
    details: '详情',
    view: '查看',
    hide: '隐藏',
    expand: '展开',
    collapse: '收起',
    running: '运行中',
    stopped: '已停止',
    done: '完成',
    success: '成功',
    warning: '警告',
    // 状态枚举
    buyAction: '买入',
    watchAction: '观察',
    skipAction: '跳过',
    continueAction: '继续',
    low: '低',
    medium: '中',
    high: '高',
    // 表格列名
    colSymbol: '代码',
    colDecision: '决策',
    colWhy: '原因',
    blockLabel: '阻断',
    warnLabel: '警告',
    colStrategies: '策略',
    colLiquidity: '流动性',
    colValidation: '验证',
    colWhyMatched: '匹配原因',
    colGrade: '评级',
    colRank: '排名',
    colSource: '来源',
    colReturn1Y: '1年收益',
    colSharpe: '夏普',
    colMaxDD: '最大回撤',
    colWinRate: '胜率',
    colPFactor: '盈亏比',
    colTrades: '交易数',
    colParams: '参数',
    colLabel: '等级',
    colStability: '稳定性',
    colTrend: '趋势',
    colVerdict: '判定',
    colRiskGate: '风险门控',
    colAnalysisReason: '分析原因',
    colSrc: '来源',
    colCurrent: '当前',
    colEntryZone: '入场区间',
    colStop: '止损',
    colTargets: '目标',
    colPosition: '仓位',
    colAIDecision: 'AI 决策',
    colGate: '门控',
    colFinalAction: '最终操作',
    colData: '数据',
    colPrice: '价格',
    colChange: '涨跌',
    colNews: '新闻/情绪',
    colDataQual: '数据质量',
    colScore: '评分',
    colRisk: '风险',
    colPriceChg: '价格/涨跌',
    colSelectionReason: '选择原因',
    // Alpaca
    alpacaMarketDataAPI: 'Alpaca 市场数据 API',
    internalBacktestEngine: '内部回测引擎',
    internalOptimizationEngine: '内部优化引擎',
    deterministicRules: '确定性规则',
    ruleBasedRiskGate: '基于规则的风险门控',
    // 弹窗/确认
    confirmLiveTrading: '输入 "{expected}" 以确认实盘交易',
    confirmAction: '输入 "{expected}" 以确认',
    cleared: '观察列表已清空',
    addedToExecution: '{symbol} 已加入 AI 执行。',
    removedFromWatchlist: '{symbol} 已从观察列表移除',
    alreadyInExecution: '{symbol} 已在执行列表中。',
    noSymbol: '请输入代码。',
    // 时间范围
    oneDay: '1天',
    oneWeek: '1周',
    oneMonth: '1个月',
    oneYear: '1年',
    all: '全部',
    changeLabel: '变动',
    // AI 配置
    aiConfigLoadFailed: 'AI 配置加载失败，保留现有配置',
    stoppingScanner: '正在停止扫描器...',
    // 订单
    orderCanceled: '订单已取消',
    orderCancelFailed: '取消失败',
    orderFailed: '订单失败',
    noOrderId: '未找到订单 ID。',
    alreadyFilled: '订单已成交，持仓已移至当前持仓。',
    // 继续扫描 AI
    selectedReason: '已选择{sectorText}：{nameOrSymbol} 具有 {trendDesc}、{newsDesc} 新闻情绪、{riskDesc} 风险和 {volDesc} 成交量{priceText}。精细扫描应在入场计划前验证形态质量和回测一致性。',
    // 流水线消息
    autoExecInfo: '自动执行：{total} 个候选中 {submitted} 个已提交，{failed} 个失败。',
    pipelineCompleteMsg: '流水线完成！{execCount} 个执行候选，{watchCount} 个加入观察列表{exitMsg}。',
    entryPlanPartial: '入场计划部分完成：部分标的存在错误（{symbols}）',
    aiModePaperDesc: 'AI 模式 + 模拟交易：符合条件的 BUY 计划将自动提交到模拟交易，BLOCK 计划仅保留审查。',
    aiModeLiveDesc: 'AI 模式 + 实盘交易：符合条件的 BUY 计划将自动提交到实盘交易，BLOCK 计划仅保留审查。',
    hybridModeDesc: '混合模式：候选标的已准备好供您审查和手动提交。',
    manualModeDesc: '手动模式：从观察列表暂存候选标的并手动提交订单。',
    symbolAnalysis: '标的分析',
    epDecisionSetup: '决策与配置',
    epEntryExitLevels: '入场 / 出场价格',
    epRiskData: '风险与数据',
    epAnalysisWarnings: '分析与警告',
    finalAction: '最终操作',
    aiDecision: 'AI 决策',
    readiness: '准备状态',
    setupType: '策略类型',
    nextTacticalStep: '下一步策略动作',
    takeProfit1: '止盈 1',
    takeProfit2: '止盈 2',
    riskReward1: '风险回报比 1',
    riskReward2: '风险回报比 2',
    portfolioRisk: '投资组合风险',
    technicalScore: '技术评分',
    regimeFilter: '市场环境过滤',
    reasoning: '分析推理',
    riskNotes: '风险说明',
    blockers: '阻断因素',
    statusReady: '就绪',
    statusWaitingEntry: '等待入场',
    statusBlocked: '已阻断',
    statusWatchOnly: '仅观察',
    statusStale: '数据过期',
    statusReview: '需审核',
    statusGood: '良好',
    statusNA: '不适用',
    buyLabel: '买入',
    epWatchLabel: '观察',
    waitLabel: '等待',
    // 预检
    sessionExpired: '会话已过期',
    alpacaNotConfigured: '未配置 Alpaca 市场数据 API。',
    // 持仓表格
    asset: '资产',
    marketValue: '市值',
    avgEntry: '均价',
    plDollar: '盈亏 ($)',
    plPercent: '盈亏 (%)',
    longSide: '多头',
    shortSide: '空头',
    // 组合
    portfolio: '投资组合',
    accountOverview: '账户概览、持仓与绩效',
    accountSnapshot: '账户快照',
    portfolioPerformance: '组合绩效',
    noPortfolioHistory: '暂无组合历史数据',
    accountDetails: '账户详情',
    accountId: '账户 ID',
    currency: '货币',
    noOpenPositions: '暂无持仓',
    // 溯源标签
    marketSourceLabel: '市场：',
    backtestLabel: '回测：内部',
    optLabel: '优化：内部',
    verdictLabel: '判定：基于规则',
    riskGateLabel: '风险门控：',
    decisionLabel: '决策',
    explainLabel: '解释',
    // 扫描状态
    idle: '空闲',
    // Alpaca 标签
    alpaca: 'ALPACA',
    // 执行表格
    typeTif: '类型 / 有效期',
    market: '市价',
    limit: '限价',
    stopOrder: '止损',
    stopLimit: '止损限价',
    trailStop: '追踪止损',
    day: '当日',
    gtc: '撤销前有效',
    draft: '草稿',
    cancelOrder: '取消订单',
    cancelBeforeRemoving: '移除前请先取消',
    retryOrder: '重试',
    removeOrder: '移除',
    reviewOnly: '仅审核',
    submitPaper: '提交模拟',
    confirmLive: '确认实盘',
    // 订单确认弹窗
    confirmRealOrder: '确认实盘订单',
    confirmPaperOrder: '确认模拟订单',
    entryPlanRecommends: '入场计划建议',
    shares: '股',
    buyBy: '购买方式',
    dollarAmount: '金额',
    orderType: '订单类型',
    trailingStop: '追踪止损',
    limitPrice: '限价',
    stopPrice: '止损价',
    trailPrice: '追踪价格',
    trailPercent: '追踪百分比',
    timeInForce: '有效期',
    gtcLabel: '撤销前有效 (GTC)',
    iocLabel: '立即成交或取消 (IOC)',
    fokLabel: '全部成交或取消 (FOK)',
    estCost: '预估成本',
    realTradingWarning: '实盘交易 — 将使用真实资金下单。',
    confirmRealOrderPlaceholder: '输入: CONFIRM REAL ORDER {symbol}',
    submitRealOrder: '提交实盘订单',
    submitPaperOrder: '提交模拟订单',
    keepOrder: '保留订单',
    cancelOrderConfirm: '取消此订单？',
    // AI 观察列表
    activeEntryMonitoring: '活跃入场监控',
    searchSymbol: '搜索代码...',
    noAIWatchlistCandidates: '暂无 AI 观察列表候选',
    addFromEntryPlan: '从入场计划添加候选，自主监控入场条件。',
    total: '总计',
    waitingEntry: '等待入场',
    reviewRequired: '需审核',
    readyOrHot: '就绪 / 热门',
    alpacaRealTimeFeed: 'ALPACA 实时数据',
    chgPercent: '涨跌%',
    stopTarget: '止损 / 目标',
    addToExecution: '加入执行队列',
    alreadyInExecutionTooltip: '已在执行列表中',
    removeFromWatchlistTooltip: '从观察列表移除',
    buyThisStock: '买入此股票',
    // 市场扫描器
    scanningInProgress: '扫描进行中',
    scanStopped: '扫描已停止',
    scanCompleted: '扫描已完成',
    scanError: '扫描错误',
    waitingForNextScan: '等待下次扫描',
    complete: '完成',
    symbolsProcessed: '个代码已处理',
    validated: '已验证',
    retries: '重试',
    lastFailure: '最后失败',
    currentlyScanning: '正在扫描',
    marketScanSummary: '市场扫描摘要',
    fullMarketScan: '全市场扫描',
    notScanned: '未扫描',
    universeScanned: '扫描范围',
    bullish: '看涨',
    bearish: '看跌',
    neutral: '中性',
    strongTrend: '强趋势',
    newsRisk: '新闻风险',
    topMarketTrends: '热门市场趋势',
    strong: '强',
    dataQuality: '数据质量',
    goodData: '良好',
    partialData: '部分',
    notConfiguredAI: '未配置',
    collecting: '采集中...',
    noDataYet: '暂无数据',
    localRules: '本地规则',
    ruleBasedOnly: '仅规则',
    noAnalysisAvailable: '暂无分析',
    noMarketScanResults: '暂无市场扫描结果',
    clickRunScanner: '点击"运行扫描"开始扫描市场',
    // 市场扫描器 - 状态标签
    statusScanning: '扫描中',
    statusCompleted: '已完成',
    statusError: '错误',
    statusStopping: '停止中',
    statusStopped2: '已停止',
    statusIdle: '空闲',
    statusRunning: '运行中',
    statusScannerReady: '就绪',
    // 市场扫描器 - 进度
    progressSymbols: '股票',
    progressCompletedPrefix: '已完成',
    progressStoppedAtPrefix: '停止于',
    progressIdleText: '空闲',
    // 市场扫描器 - 继续扫描标签
    sourceLabel: '来源',
    selectionLabel: '选择',
    poolLabel: '池',
    symbolsLabel: '股票',
    // 市场扫描器 - 详情面板
    lastAnalysis: '上次分析',
    analysisSource: '分析来源',
    localRulesLabel: '本地规则',
    localLabel: '本地',
    trendLabel: '趋势',
    marketBasicInfo: '市场与基础信息',
    currentPrice: '当前价格',
    change24h: '24小时涨跌',
    dayLow: '日内最低',
    dayHigh: '日内最高',
    volumeLiquidity: '成交量与流动性',
    sectorLabel: '板块',
    industryLabel: '行业',
    dataProvenances: '数据来源',
    marketDataLabel: '市场数据',
    fundamentalsLabel: '基本面',
    sentimentLabel: '情绪',
    detailedSourceUnavailable: '详细来源映射不可用',
    analysisScores: '分析与评分',
    overallTrendScore: '综合趋势评分',
    confidenceLevel: '置信度',
    dimensionalBreakdown: '维度拆解',
    dimTrend: '趋势',
    dimMomentum: '动量',
    dimVolume: '成交量',
    dimVolatility: '波动率',
    dimStructure: '结构',
    dimSentiment: '情绪',
    riskPrefix: '风险',
    volPrefix: '波动',
    volHigh: '高',
    volStable: '稳定',
    aiAgentReasoning: 'AI 代理推理',
    detailedAnalysis: '详细分析',
    latestMarketNews: '最新市场新闻',
    noSymbolNews: '最近24小时内未找到该股票的新闻。',
    newsConsistent: '已识别近期新闻头条。情绪与当前趋势评分保持一致。',
    agentRecommendation: '代理建议',
    recommendedNextStep: '建议下一步',
    strategicReasoning: 'AI 代理战略推理',
    compilingReasoning: 'AI 代理正在为该候选股票整理战略推理...',
    noDetailedAnalysis: '该股票暂无详细分析。',
    unknownCompany: '未知公司',
    // 精细扫描详情面板
    matchSummary: '匹配摘要',
    strategyBacktest: '策略回测验证',
    quickOptimization: '快速参数优化',
    surgicalEntry: '精确入场分析',
    highConvictionSignals: '高置信度信号',
    liquidityRiskProfile: '流动性与风险概况',
    newsAndCatalyst: '新闻与市场催化剂',
    evaluationPeriod: '评估周期',
    backtestNotAvailable: '该候选股票暂无回测数据。',
    optimizationNotAvailable: '该候选股票未执行优化。',
    optimizationInProgress: '优化进行中...',
    entryQualityUnavailable: '入场质量指标暂不可用。',
    setupScore: '形态评分',
    noSignificantNews: '未检测到近期重大新闻催化剂。',
    newsSentimentUnavailable: '新闻情绪分析不可用。',
    viewMoreHeadlines: '在终端中查看其余 {count} 条头条...',
    noDataLabel: '无数据',
    // 市场扫描器 - 内容标签
    sentimentPositive: '正面',
    sentimentNegative: '负面',
    sentimentMixed: '混合',
    riskHigh: '高',
    riskMedium: '中',
    riskLow: '低',
    volumeHigh: '高',
    volumeNormal: '正常',
    volumeLow: '低',
    trendStrongBullish: '强烈看涨',
    trendBullish: '看涨',
    trendNeutral: '中性',
    trendBearish: '看跌',
    trendStrongBearish: '强烈看跌',
    // 继续扫描
    selectionSuccessful: '选择成功',
    foundTopCandidates: '找到 {count} 个顶级候选，可供后续分析。',
    avgPriority: '平均优先级',
    riskMix: '风险分布 (低/中/高)',
    avgScore: '平均评分',
    aiCoverage: 'AI 覆盖率',
    aiRules: 'AI + 规则',
    rulesOnly: '仅规则',
    source: '来源',
    pool: '池',
    lastSync: '最后同步',
    scoreBreakdown: '评分明细',
    weight: '权重',
    selectionDisclosure: '选择说明：这些候选经过主扫描器筛选和优先级加权。请运行精细扫描以验证策略匹配度和回测质量。',
    noMarketScanResultsAvailable: '暂无市场扫描结果',
    marketScanInProgress: '市场扫描进行中...',
    scanStoppedBeforeResults: '扫描在收集结果前已停止。',
    runMarketScannerFirst: '请先运行市场扫描器以建立继续扫描候选列表。',
    ruleBasedScanInProgress: '基于规则的扫描进行中...',
    processingNCandidates: '正在处理第 {processed} / {total} 个候选',
    noSuitableCandidates: '未找到合适候选',
    noBullishCandidatesMet: '市场扫描完成，但没有看涨候选满足继续扫描条件',
    continueScanFailed: '继续扫描处理失败',
    continueScanError: '处理继续扫描候选时发生错误',
    readyToStartContinueScan: '准备开始继续扫描',
    builtFromPartialResults: '基于部分扫描结果：{processed}/{total} 个代码',
    marketScanCompletedResults: '市场扫描完成，共 {count} 个结果',
    clickStartContinueScan: '点击"开始继续扫描"对当前结果运行基于规则的选择',
    startSelection: '开始选择',
    processing: '处理中...',
    displaying: '显示',
    of: '/',
    candidatesWord: '个候选',
    // 精细扫描
    scanningRegimeStrategies: '扫描市场环境与策略',
    fineScanInterrupted: '扫描中断',
    processProgress: '处理进度',
    retained: '已保留',
    candidatesLabel: '候选:',
    continueLabel: '继续:',
    watchLabel: '观察:',
    rejectLabel: '拒绝:',
    needDataLabel: '需数据:',
    aiAgentLabel: 'AI 代理:',
    systemReady: '系统就绪，可进行多维度策略确认',
    awaitingInput: '等待 Market Scanner 候选股票',
    runFineScan: '运行精细扫描',
    fineScanRunning: '运行中...',
    excellent: '优秀',
    wait: '等待',
    nearRes: '接近阻力',
    poorRR: '风险收益差',
    fineScanNoData: '无数据',
    backtestLabelShort: '回测: ',
    positive: '正向',
    negative: '负向',
    caution: '谨慎',
    optLabelShort: '优化: ',
    fineScanStable: '稳定',
    weak: '弱',
    overfitRisk: '过拟合风险',
    overfit: '过拟合',
    whyMatchedTooltip: 'AI 生成的解释',
    whyMatchedTemplate: '基于模板（市场数据）',
    noCandidatesToAnalyze: '暂无候选可分析。请先运行继续扫描。',
    errorDuringFineScan: '精细扫描期间发生错误',
    runFineScanToMatch: '运行精细扫描为继续列表候选匹配策略',
    step1Regime: '步骤 1：市场环境与策略匹配',
    step3QuickBacktest: '步骤 3：快速回测验证',
    // 深度验证
    validating: '验证中...',
    validatingLabel: '验证中',
    interruptedLabel: '已中断',
    riskGatePass: '风险门控通过',
    confirmed: '已确认',
    systemMonteCarlo: '系统',
    monteCarloV2: '蒙特卡洛 v2',
    readyForHistorical: '准备进行历史压力测试。',
    candidatesAvailable: '个候选可用。',
    systemPerformingValidation: '系统正在进行多环境风险验证...',
    runningDeeperValidation: '正在运行深度验证',
    backtestOptStability: '回测、优化与稳定性分析 — 多个代码可能需要 1-3 分钟',
    validationFailed: '验证失败',
    checkBackendLogs: '请检查后端日志或重试。',
    failedSymbols: '失败的代码:',
    candidatesFromFineScan: '个精细扫描候选准备进行深度验证。',
    continuePlusWatch: '继续 + 观察验证',
    scoreGe50: '评分 ≥ 50，无关键阻断',
    completeFineScanFirst: '请先完成精细扫描以启用深度历史验证。',
    // 入场计划
    epGenerating: '生成中...',
    generatingLabel: '生成中',
    interruptedLabel2: '已中断',
    runEntryPlan: '运行入场计划',
    noValidatedCandidatesYet: '暂无已验证候选。请先运行深度验证。',
    noConfirmedOrWatch: '深度验证中没有已确认或观察的候选。',
    validatedCandidatesReady: '个已验证候选就绪。点击',
    toGenerateEntryPlans: '生成入场计划。',
    computingEntryZones: '正在计算入场区间、止损、仓位大小和风险门控...',
    entryPlanFailed: '入场计划生成失败。请重试。',
    aiDecisions: 'AI 决策',
    skipLabel: '跳过',
    localRulesNoAICall: '本地规则（无 AI 调用）',
    riskReview: '风险审查',
    passed: '通过',
    review: '审核',
    blocked: '已拦截',
    tradeReadiness: '交易就绪',
    ready: '就绪',
    blockedLabel: '已拦截',
    execution: '执行',
    aiModePaperReady: 'AI 模式 · 模拟执行就绪',
    aiModeLiveConfirm: 'AI 模式 · 自动执行就绪',
    hybridModeManual: '混合模式 · 手动执行',
    manualModeRecommendations: '手动模式 · 仅建议',
    paperPreviewOnly: '自动提交订单',
    manualConfirmRequired: '自动提交订单',
    noAutomaticOrders: '无自动订单',
    manualOnly: '仅手动',
    realTradingRequiresConfirm: '实盘交易需手动确认。不会自动下单。',
    executionPlan: 'A. 执行计划',
    positionRisk: 'B. 仓位与风险',
    decision: 'C. 决策',
    dataQualityCard: 'D. 数据质量',
    epCurrentPrice: '当前价格',
    distance: '距离',
    epTrigger: '触发',
    epTargets: '目标',
    epInvalidation: '失效条件',
    orderTypeSuggestion: '订单类型',
    epPortfolio: '投资组合',
    epBuyingPower: '购买力',
    riskBudget: '风险预算',
    actualRisk: '实际风险',
    riskUsed: '已用风险',
    ofRiskBudget: '占风险预算',
    size: '仓位',
    estValue: '预估价值',
    capStatus: '上限状态',
    cappedAt: '上限为',
    okAt: '正常（{pct} 占权益）',
    epAIDecision: 'AI 决策',
    epConfidence: '置信度',
    epRiskGate: '风险门控',
    tradeReadinessLabel: '交易就绪',
    entryTrigger: '入场触发',
    readyOrWaiting: '就绪',
    waiting: '等待中',
    bestStrategy: '最佳策略',
    accountData: '账户数据',
    aiProviderLabel: 'AI 供应商',
    localRulesFallback: '本地规则回退',
    noAIProviderConfigured: '未配置 AI 供应商或调用失败',
    broker: '券商',
    notConnected: '未连接',
    aiErrorLabel: 'AI 错误',
    decisionReason: '决策原因',
    noDetailedReasoning: '暂无详细推理。',
    nextStep: '下一步',
    waitForFurtherSignals: '等待进一步信号。',
    riskComment: '风险评论',
    riskAssessment: '风险评估',
    noRiskWarnings: '未识别风险警告。',
    criticalBlockers: '关键阻断',
    epExecuteTrade: '执行交易',
    reviewAndExecute: '审核并执行',
    epMonitorEntry: '监控入场',
    planSkipped: '计划已跳过',
    epRiskBlocked: '风险拦截',
    inWatchlist: '已在观察列表',
    inZone: '在区间内',
    fromEntry: '距入场',
    pullback: '回调',
    breakout: '突破',
    support: '支撑',
    localRulesTooltip: '本地规则 — 无 LLM 调用。未配置 AI 供应商或调用失败。',
    execute: '执行',
    skipped: '已跳过',
    update: '更新',
    plusWatchlist: '+ 观察列表',
    // 退出扫描
    evaluateHoldings: '评估当前持仓并开启卖出计划的退出就绪度。',
    scanned: '已扫描',
    sellNow: '立即卖出',
    targetLimit: '目标限价',
    hold: '持有',
    epPending: '待处理',
    epSubmitted: '已提交',
    runExitScan: '运行退出扫描',
    reRunExitScan: '重新运行退出扫描',
    stopScanner: '停止',
    noExitScanResults: '暂无退出扫描结果',
    clickRunExitScan: '点击"运行退出扫描"分析当前持仓的退出机会。',
    scanningHoldings: '正在扫描持仓...',
    noHoldingsRequireReview: '暂无持仓需要退出审核',
    exitScanEvaluates: '退出扫描评估当前持仓和现有卖单。',
    clearResults: '清除结果',
    noActiveHoldings: '暂无活跃持仓可扫描',
    exitPrice: '退出价格',
    sellNowLabel: '立即卖出',
    targetLimitLabel: '目标限价',
    holdLabel: '持有',
    manualReviewLabel: '审核',
    blockedLabelExit: '已拦截',
    mktSell: '市价卖出',
    lmtSell: '限价卖出',
    noOrder: '无订单',
    // 执行确认弹窗
    liveTradingConfirmation: '实盘交易确认',
    confirmOrderExecution: '确认订单执行',
    liveTradingUsesRealMoney: '实盘交易使用真实资金。提交前请确认。',
    confirmLiveOrder: '确认实盘订单',
    submitOrder: '提交订单',
    symbolLabel: '代码',
    setupLabel: '形态',
    orderTypeLabel: '订单类型',
    sharesLabel: '股数',
    entryZoneLabel: '入场区间',
    estimatedValue: '预估价值',
    maxRisk: '最大风险',
    stopLossLabel: '止损',
    takeProfitLabel: '止盈',
    modeLabel: '模式',
    confirmLiveBuy: '输入 {text} 以确认:',
    belowEntry: '低于入场区间 ${diff}（{pct}%）', // eslint-disable-line no-template-curly-in-string
    aboveEntry: '高于入场区间 ${diff}（{pct}%）', // eslint-disable-line no-template-curly-in-string
    inEntryZone: '在入场区间内',
    noReasonProvided: '暂无原因',
    invalidationLabel: '失效条件：',
    colSetup: '形态',
    colQty: '数量',
    colAvgEntry: '均价',
    colPL: '盈亏',
    colPLPct: '盈亏%',
    colExitDecision: '决策',
    colExitOrder: '订单',
    colExitStatus: '状态',
    reviewLabel: '审核',
    epNoDetailedAnalysis: '暂无详细分析',
    filledLabel: '已成交',
    failedLabel: '失败',
    scanningLabel: '扫描中',
    completedLabel: '已完成',
    skippedLabel: '已跳过',
    errorLabel: '错误',
    stoppedLabel: '已停止',
    epLocalRules: '本地规则',
    colTarget: '目标',
    unknown: '未知',
    // 精细扫描详情 - 表头
    btColStrategy: '策略',
    btColReturn: '收益',
    btColSharpe: '夏普',
    btColMaxDD: '最大回撤',
    btColWinPct: '胜率%',
    btColTrades: '交易数',
    btColStatus: '状态',
    optColStrategy: '策略',
    optColStability: '稳定性',
    optColAvgReturn: '平均收益',
    optColPosRatio: '正收益比',
    optColSpread: '分布',
    // 精细扫描详情 - 状态标签
    statusPass: '通过',
    statusCaution: '谨慎',
    statusFail: '失败',
    statusStable: '稳定',
    statusWeak: '弱',
    statusOverfit: '过拟合',
    // 精细扫描详情 - 前缀标签
    scorePrefix: '评分 ',
    blockPrefix: '阻断: ',
    dataPrefix: '数据: ',
    limitedSampleTag: '样本有限',
    localRulesTag: '本地规则',
    deepseekTag: 'DEEPSEEK V4 FLASH',
    // 精细扫描详情 - 溯源芯片
    provenanceMkt: '市场扫描器',
    provenanceBt: '回测引擎',
    provenanceOpt: '优化器',
    provenanceEntry: '入场分析',
    provenanceNews: '新闻聚合',
    provenanceDecision: '决策: ',
    provenanceAI: 'AI',
    provenanceRules: '规则',
    // 精细扫描详情 - 流动性/风险标签
    liquidityLabel: '流动性',
    tagGrade: '评级',
    tagRvol: '相对成交量',
    tagSpread: '价差',
    tagScore: '评分',
    tagAtr: 'ATR',
    tagPrice: '价格',
    tagSupport: '支撑',
    tagResistance: '阻力',
    tagZone: '区间',
    tagStop: '止损',
    tagRR: '风险/收益',
    // 精细扫描详情 - 新闻标签
    tagSentiment: '情绪',
    tagHeadlines: '头条数',
    tagEarnings: '财报',
    earningsUpcoming: '即将',
    earningsClear: '无',
    // 精细扫描详情 - AI 推理
    tagSource: '来源',
    tagTokens: 'Token',
    tokensOptimized: '已优化',
    rrCapped: '风险/收益受限: ',
    // 精细扫描详情 - 市场环境
    regimeLabel: '市场环境',
    regimeTrending: '趋势',
    regimeBreakout: '突破就绪',
    regimeRange: '区间震荡',
    regimeUnclear: '不明',
    // 精细扫描详情 - 流动性详情标签
    liquiditySubLabel: '流动性',
    // 精细扫描 - 补充
    partialLabel: '部分',
    processingMarketData: '正在处理所选候选的市场数据...',
    // 深度验证详情 - 补充
    naLabel: '不适用',
    ruleBasedLabel: '基于规则',
    gatePrefix: '风控',
    gateBlocked: '已阻断',
    paramRet: '收益',
    paramSharpe: '夏普',
    dvTrendDivergent: '分歧',
    dvReasonConfirmed: '已确认',
    dvReasonWatch: '观察',
    dvReasonReject: '拒绝',
    dvReasonRecentWeakening: '近期转弱',
    dvReasonParamProfitable: '参数组合盈利',
    dvReasonMedianReturn: '中位收益',
    dvReasonMedianSharpe: '中位夏普',
    dvReasonProfitFactor: '盈亏因子',
    dvReasonSharpe: '夏普比率',
    dvReasonReturn: '收益率',
    dvReasonDrawdown: '回撤',
    dvReasonWinRate: '胜率',
    dvReasonTrades: '交易数',
    dvReasonSampleLimited: '样本有限',
    dvReasonStabilityReason: '稳定性评估',
  },
  trade: {
    title: '交易工作台',
    subtitle: '监控账户权益、管理持仓，并直接向 Alpaca 下单。',
    paperTrading: '模拟交易',
    liveTrading: '实盘交易',
    refreshData: '刷新数据',
    autoRefreshOn: '自动刷新：开',
    autoRefreshOff: '自动刷新：关',
    updated: '更新时间',
    realTimeData: '实时行情',
    realModeTitle: '实盘交易模式',
    realModeDesc: 'Alpaca 实盘账户数据已激活。订单将使用真实资金执行。',
    watchlistTitle: 'AI 入场观察列表',
    watchlistSubtitle: '自动标的监控',
    refresh: '刷新',
    noWatchlist: '暂无 AI 观察候选',
    noWatchlistDesc: '入场计划的候选标的将在此显示以供监控。',
    statActive: '活跃',
    statReadySoon: '即将就绪',
    statReview: '审核',
    statArchived: '已归档',
    colSymbol: '标的',
    colSetup: '形态',
    colAI: 'AI',
    colCnf: '置信',
    colEntryZone: '入场区间',
    colStop: '止损',
    colTarget: '目标',
    colRR: '风险/收益',
    colGate: '风控',
    colFinal: '最终',
    colNextStep: '下一步操作',
    buy: '买入',
    remove: '移除',
    finalBuyReady: '准备买入',
    finalWaitEntry: '等待入场',
    finalSkip: '跳过',
    finalBlocked: '已阻断',
    accountSnapshot: '账户快照',
    newOrder: '新建订单',
    reviewOrder: '审核订单',
    finalConfirmation: '最终确认',
    confirmPlaceReal: '确认并提交实盘订单',
    placeRealOrder: '提交实盘订单',
    placePaperOrder: '提交模拟订单',
    paperTradingLabel: '模拟交易',
    realTradingLabel: '实盘交易',
    cash: '现金',
    equity: '权益',
    buyingPower: '购买力',
    portfolioValue: '组合价值',
    accountLabel: '账户',
    statusLabel: '状态',
    positionsLabel: '持仓',
    openOrdersLabel: '未平仓订单',
    portfolioPerformance: '组合表现',
    periodChange: '期间变动',
    portfolioValueLabel: '组合价值',
    periodOpen: '期初权益',
    periodHigh: '区间最高',
    periodLow: '区间最低',
    maxDrawdown: '最大回撤',
    drawdown: '回撤',
    openingBaseline: '期初基准线',
    observations: '个数据点',
    easternTime: '美东时间',
    loadingPortfolio: '加载组合数据中...',
    portfolioUnavailable: '组合历史不可用',
    portfolioUnavailableDesc: '请检查 Alpaca 凭证和连接。',
    noPortfolioHistory: '暂无组合历史数据',
    noPortfolioHistoryDesc: 'Alpaca 未返回所选时段的数据。',
    range1Day: '1 天',
    range1Week: '1 周',
    range1Month: '1 月',
    range3Months: '3 月',
    range1Year: '1 年',
    rangeAll: '全部',
    positions: '持仓',
    noPositions: '该账户暂无持仓。',
    openOrders: '未平仓订单',
    noOpenOrders: '该账户暂无活跃订单。',
    orderHistory: '订单历史',
    noOrderHistory: '暂无订单历史。',
    colAsset: '资产',
    colPrice: '价格',
    colQty: '数量',
    colSide: '方向',
    colMarketValue: '市值',
    colAvgEntry: '平均入场',
    colCostBasis: '成本基础',
    colTodayPLPct: '今日盈亏%',
    colTodayPL: '今日盈亏',
    colTotalPLPct: '总盈亏%',
    colTotalPL: '总盈亏',
    colType: '类型',
    colLimitPrice: '限价',
    colStopPrice: '止损价',
    colTIF: '有效期',
    colCreated: '创建时间',
    cancel: '取消',
    colTime: '时间',
    colAvgFillPrice: '平均成交价',
    colFilledQty: '已成交数量',
    invalidDate: '无效日期',
    cancelOrderTitle: '确认取消{symbol}的订单？',
    cancelOrderLiveDesc: '这将取消您实盘 Alpaca 账户上的订单。此操作无法撤销。',
    cancelOrderPaperDesc: '这将取消您{mode}账户上的订单。',
    cancelLiveOrder: '取消实盘订单',
    cancelOrder: '取消订单',
    keepOrder: '保留订单',
    orderCancelled: '订单已成功取消',
    cancelFailed: '取消失败',
    orderPlaced: '下单成功',
    refreshFailed: '刷新数据失败',
    removeFailed: '移除失败',
    paperLabel: '模拟',
    liveLabel: '实盘',
    credentialsNotConfigured: '{mode}交易凭证未配置。请在设置中保存 API 密钥。',
    sell: '卖出',
  },
  portfolio: {
    title: '投资组合',
    subtitle: '账户概览、持仓与表现',
    refresh: '刷新',
    accountSnapshot: '账户快照',
    cash: '现金',
    equity: '权益',
    buyingPower: '购买力',
    portfolioValue: '组合价值',
    accountLabel: '账户',
    statusLabel: '状态',
    positionsLabel: '持仓数',
    openOrdersLabel: '未平仓订单',
    portfolioPerformance: '组合表现',
    change: '变动',
    noPortfolioHistory: '暂无组合历史数据',
    portfolioHistoryLoadFailed: '组合历史加载失败',
    fallbackHistoryNote: '使用当前账户权益生成的参考曲线',
    fallbackHistoryBanner: '显示的是估算历史数据 — 请连接 Alpaca 组合历史以获取经过验证的账户权益。',
    verifiedAlpacaHistory: '已验证的 Alpaca 历史数据',
    dataSourceAlpaca: '数据来源：Alpaca',
    range1Day: '1 天',
    range1Week: '1 周',
    range1Month: '1 月',
    range3Months: '3 月',
    range1Year: '1 年',
    rangeAll: '全部',
    accountDetails: '账户详情',
    accountID: '账户 ID',
    status: '状态',
    currency: '货币',
    positions: '持仓',
    noPositions: '暂无持仓',
    colAsset: '资产',
    colPrice: '价格',
    colQty: '数量',
    colSide: '方向',
    colMarketValue: '市值',
    colAvgEntry: '平均入场',
    colPL: '盈亏($)',
    colPLPct: '盈亏(%)',
    mode: '模式',
    currentPaperTrading: '当前：模拟交易',
    currentRealTrading: '当前：实盘交易',
    paperTrading: '模拟交易',
    realTrading: '实盘交易',
    sourcePaper: 'Alpaca 模拟',
    sourceReal: 'Alpaca 实盘',
    apiErrorTitle: '投资组合数据不可用',
    configureAction: '打开配置',
    dataUnavailable: '无法从后端加载投资组合数据。',
    todayPL: '今日盈亏',
    totalUnrealizedPL: '未实现盈亏',
    dayTradeBuyingPower: '日内购买力',
    maintenanceMargin: '维持保证金',
    holdings: '当前持仓',
    summary: '账户摘要',
    accountStatus: '账户状态',
    tradingMode: '交易模式',
    dataSource: '数据来源',
    lastUpdated: '最后更新',
    exposure: '仓位暴露',
    riskStatus: '风险 / 暴露',
    riskClear: '正常',
    tradingBlocked: '交易受限',
    accountBlocked: '账户受限',
    patternDayTrader: '日内交易账户',
    realModeNote: '实盘模式使用你的 Alpaca 真实账户数据。',
    paperModeNote: '模拟模式使用你的 Alpaca 模拟账户数据。',
    noPortfolioHistoryDesc: 'Alpaca 返回账户历史后会显示组合曲线。',
    portfolioValueLine: '组合总价值',
    profitLossLine: '盈亏',
    colCurrentPrice: '当前价格',
    colCostBasis: '成本基础',
    colTodayChange: '今日变化',
    tooltipTime: '时间',
    tooltipEquity: '总资产',
    tooltipChange: '变动',
    tooltipChangePct: '变动百分比',
  },
  settings: {
    title: '设置',
    subtitle: '管理连接、显示偏好和账户访问。',
    tradingProvider: '交易提供商',
    intelligence: 'AI 智能',
    marketData: '市场数据',
    configured: '已配置',
    notConfigured: '未配置',
    checking: '加载中...',
    aiProvider: 'AI 提供商',
    platformManagement: '平台管理',
    connectionConfig: '连接配置',
    connectionConfigDesc: '为所有外部量化服务配置并测试 API 密钥。',
    securityAccount: '安全与账户',
    accountInfo: '账户信息',
    loggedInAs: '当前登录账号',
    securitySettings: '安全设置',
    signOut: '退出登录',
    footerNote: '已保存凭证在界面中以遮罩形式显示。如果怀疑泄露，请到对应提供商后台轮换密钥。',
  },
  config: {
    title: '连接',
    subtitle: '保存并测试研究工作区使用的外部服务。',
    backToSettings: '返回设置',
    signOut: '退出登录',
    footerSecurity: '密钥保存后只显示遮罩值。如需轮换或撤销，请前往对应提供商后台操作。',
    pleaseSignIn: '请先登录后再保存设置。',
    saveFailed: '保存失败',
    connectionFailed: '连接失败',
    statusConnected: '已连接',
    statusSaved: '已保存',
    statusError: '错误',
    statusNotTested: '未测试',
    paperTitle: 'Alpaca 模拟交易',
    paperSubtitle: '模拟交易环境的凭证。',
    paperSaved: '模拟交易设置已保存',
    paperTestOK: '模拟连接正常 — 账户: {id}',
    apiKey: 'API 密钥',
    secretKey: '密钥',
    endpointUrl: '端点 URL',
    savedMasked: '已保存（已遮罩）',
    enterApiKey: '请输入 API 密钥',
    enterSecretKey: '请输入密钥',
    testConnection: '测试连接',
    saveChanges: '保存更改',
    paperSecurityNote: '模拟密钥仅用于测试，不涉及真实资金。',
    alpacaWebsite: 'Alpaca API 官网',
    finnhubWebsite: 'Finnhub API 官网',
    liveTitle: 'Alpaca 实盘交易',
    liveSubtitle: '仅在你明确选择实盘环境时使用的凭证。',
    securityWarning: '安全警告',
    securityWarningDesc: '实盘交易涉及真实资金风险。请确保密钥安全保管且绝不共享。',
    liveSaved: '实盘交易设置已保存',
    liveTestOK: '实盘连接正常 — 账户: {id}',
    testLiveConnection: '测试实盘连接',
    saveLiveSettings: '保存实盘设置',
    marketDataTitle: 'Alpaca 行情数据',
    marketDataSubtitle: 'K 线、快照和实时行情的端点。',
    keysAutoSynced: '密钥已从实盘交易自动同步',
    configureRealFirst: '请先配置实盘交易以自动同步',
    dataEndpointUrl: '数据端点 URL',
    dataFeedTier: '数据订阅级别',
    iexFree: 'IEX（免费）',
    sipPaid: 'SIP（付费）',
    dataApiKey: '数据 API 密钥',
    dataApiSecret: '数据 API 密钥',
    usingRealKey: '使用实盘密钥',
    usingRealSecret: '使用实盘密钥',
    configureRealTrading: '请配置实盘交易',
    testDataAccess: '测试数据访问',
    saveConfiguration: '保存配置',
    marketDataSaved: '行情数据设置已保存',
    marketDataConnected: '行情数据已连接（来源: {source}）',
    aiTitle: '模型提供商',
    aiSubtitle: '研究复核所使用的提供商与模型。',
    keyMismatch: '密钥不匹配',
    keyMismatchDesc: '保存的密钥似乎是遮罩值。请重新输入实际 API 密钥以恢复服务。',
    provider: '提供商',
    primaryModel: '主模型',
    customModel: '自定义模型',
    modelIdentifier: '模型标识',
    modelPlaceholder: '例如 gpt-4o 或 deepseek-v4-flash',
    apiKeyLabel: 'API 密钥',
    apiBaseUrl: 'API 基础 URL',
    testAiConnection: '测试连接',
    saveIntelligence: '保存智能设置',
    aiSaved: 'AI 设置已保存',
    aiConnected: 'AI 连接成功',
    finnhubTitle: 'Finnhub 金融数据',
    finnhubSubtitle: '公司基本面、板块数据和财报数据提供商。',
    finnhubApiKey: 'API 密钥',
    finnhubBaseUrl: '基础 API URL',
    testFinnhub: '测试 Finnhub',
    finnhubSaved: 'Finnhub 设置已保存',
    finnhubConnected: 'Finnhub 连接已验证',
  },
  auth: {
    createAccount: '创建账户',
    signUpTitle: '开始使用 AlphaLab',
    signUpSubtitle: '创建一个默认从模拟模式开始的研究工作区。',
    trustMicrocopy: '邮箱验证 · 凭证遮罩 · 模拟优先',
    buttonTip: '完成验证以继续',
    fullName: '姓名',
    fullNamePlaceholder: '请输入你的姓名',
    emailAddress: '邮箱',
    emailPlaceholder: '请输入有效邮箱地址',
    password: '密码',
    passwordPlaceholder: '至少 8 位，须含大写字母、小写字母和数字',
    confirmPassword: '确认密码',
    confirmPasswordPlaceholder: '请再次输入密码',
    termsPrefix: '我同意',
    termsOfService: '服务条款',
    privacyPolicy: '隐私政策',
    and: '和',
    createAccountBtn: '创建账户',
    creatingAccount: '正在创建账户...',
    alreadyHaveAccount: '已有账户？',
    signIn: '登录',
    backToHome: '返回首页',
    enterFullName: '请输入你的姓名',
    enterValidEmail: '请输入有效邮箱地址',
    passwordMinLength: '密码至少需要 8 位，并包含大写字母、小写字母和数字',
    passwordPolicyError: '密码须至少 8 位，并包含大写字母、小写字母和数字',
    passwordRuleLength: '至少 8 个字符',
    passwordRuleMatch: '两次密码一致',
    passwordRuleUpper: '包含大写字母',
    passwordRuleLower: '包含小写字母',
    passwordRuleNumber: '包含数字',
    passwordsDoNotMatch: '两次输入的密码不一致',
    acceptTerms: '请同意服务条款和隐私政策',
    accountCreated: '请查看账户状态',
    accountCreatedDesc: '如果该邮箱可以注册且需要确认，你会收到一封邮件。若你已有账户，请前往登录或重置密码。',
    goToSignIn: '继续前往登录',
    accountReady: '账户已创建',
    accountReadyDesc: '此账户不需要邮箱确认，可以直接进入工作区。',
    continueToWorkspace: '进入工作区',
    resendConfirmation: '重新发送确认邮件',
    resendingConfirmation: '正在发送确认邮件…',
    confirmationResent: '如果该邮箱可以接收确认邮件，你会收到一封邮件。请仅使用最新的链接。',
    confirmationResendCaptcha: '请完成人机验证后再请求新的确认邮件。',
    confirmationResendRateLimit: '请求过于频繁，请稍后再重新发送确认邮件。',
    confirmationResendFailed: '暂时无法重新发送确认邮件，请稍后重试。',
    buildYourEdge: '设置你的研究工作区',
    featureAiTitle: '模型辅助复核',
    featureBacktestTitle: '交易前先回测',
    featurePaperTitle: '从模拟交易开始',
    signUpHint: '注册后，请在配置中心设置 Alpaca、Finnhub 和 AI 提供商密钥。',
    nextStepsTitle: '接下来会发生什么？',
    nextStep1: '验证邮箱',
    nextStep2: '准备好后连接服务',
    nextStep3: '从模拟交易开始',
    oauthHint: '登录由 Supabase Auth 处理。',
    oauthRedirecting: '跳转中...',
    oauthFailed: 'OAuth 登录失败，请重试。',
    registrationFailed: '注册失败',
    resetFailed: '发送重置邮件失败，请重试。',
    passwordUpdateFailed: '密码更新失败，请重试。',
    sending: '发送中...',
    updating: '更新中...',
    signUpHelperAll: '请完成验证并同意条款以继续',
    passwordsDoNotMatchError: '两次输入的密码不一致',
    invalidCredentials: '邮箱或密码错误',
    checkEmailConfirmation: '请检查邮箱并完成账号确认。',
    welcomeBack: '欢迎回来',
    signInSubtitle: '进入你的 AlphaLab 工作区。',
    authFeatureMarketTitle: 'AI 市场研究',
    authFeatureMarketDesc: '确定性市场扫描，并使用独立模型层审查上下文。',
    authFeatureExecutionTitle: '模拟优先执行',
    authFeatureExecutionDesc: '先在模拟环境中检验假设，再考虑连接实盘资金。',
    authFeatureSecurityTitle: '受保护的配置',
    authFeatureSecurityDesc: '提供商凭证在界面中遮盖，不通过面向浏览器的 API 响应暴露。',
    emailPlaceholderSignIn: '请输入邮箱地址',
    passwordPlaceholderSignIn: '请输入密码',
    rememberEmail: '记住邮箱',
    forgotPassword: '忘记密码？',
    signInBtn: '登录',
    signingIn: '正在登录...',
    noAccount: '还没有账户？',
    continueWith: '或使用以下方式继续',
    continueWithGoogle: '使用 Google 登录',
    continueWithGithub: '使用 GitHub 登录',
    signUpWith: '或使用以下方式注册',
    signUpWithGoogle: '使用 Google 注册',
    signUpWithGithub: '使用 GitHub 注册',
    verifyHuman: '请完成人机验证',
    authServiceUnavailable: '此部署尚未正确配置账户服务，请联系管理员。',
    captchaNotConfigured: '人机验证未配置，请联系管理员。',
    captchaBypassDev: '本地开发已跳过验证。',
    captchaLoadFailed: '人机验证加载失败。请检查网络连接后重试。',
    captchaTimedOut: '人机验证已超时，请重试以获取新的验证挑战。',
    captchaUnsupported: '当前浏览器无法运行人机验证。请使用受支持的浏览器，或关闭限制性内容拦截后重试。',
    captchaRetry: '重试验证',
    captchaReload: '重新加载页面',
    captchaRequired: '请先完成人机验证，再请求密码重置链接。',
    captchaSignInError: '请先完成人机验证后再登录。',
    forgotPasswordDesc: '输入你的邮箱地址，我们会发送密码重置链接。',
    sendResetLink: '发送重置链接',
    forgotPrivacyCopy: '你的信息受隐私政策保护，仅用于发送重置链接。',
    resetEmailSent: '密码重置邮件已发送，请检查收件箱。',
    resetEmailSentTitle: '请查收邮件',
    resetEmailSentDesc: '如果该邮箱对应有效账户，我们已发送密码重置链接。请打开链接设置新密码。',
    resetRateLimit: '邮件发送次数已达上限，请稍后再试。',
    resetPasswordTitle: '重置密码',
    resetPasswordDesc: '为你的 AlphaLab 账户设置新密码。',
    newPassword: '新密码',
    confirmNewPassword: '确认新密码',
    updatePassword: '更新密码',
    passwordUpdated: '密码已更新。现在可以登录。',
    passwordUpdatedTitle: '密码已更新',
    passwordUpdatedDesc: '新密码已经生效，请重新登录以继续使用 AlphaLab。',
    passwordUpdatedSignOutWarning: '密码已更新，但暂时无法确认所有活动会话都已退出。请重新登录，并在安全设置中撤销其他会话。',
    resetLinkInvalid: '此密码重置链接无效或已过期，请重新获取链接。',
    requestNewResetLink: '重新获取重置链接',
    backToSignIn: '返回登录',
    // P1-3 OAuth attribution
    oauthAttribution: '认证服务由 Supabase 提供',
    // P1-4 CAPTCHA footer
    captchaFooter: '由 Cloudflare Turnstile 保护',
    // P1-5 Normalized error messages
    errorEmailExists: '该邮箱已注册账号',
    errorWeakPassword: '密码强度过低。请使用至少 8 位字符，并包含大写字母、小写字母和数字。',
    errorNetworkIssue: '网络错误，请检查网络连接后重试。',
    errorUnexpected: '发生未知错误，请重试。',
    errorSessionExpired: '登录已过期，请重新登录。',
    // P3 Auth helper text
    signInHelperCaptcha: '请完成验证后继续',
    signInHelperEmpty: '请输入邮箱和密码后继续',
    signUpHelperTerms: '请同意条款后继续',
    signUpHelperCaptcha: '请完成验证后继续',
    signUpHelperPasswordMismatch: '密码必须一致',
    signUpHelperFields: '请填写所有必填项后继续',
    forgotHelperEmail: '请输入有效的邮箱地址',
    forgotHelperCaptcha: '请完成验证后继续',
    resetHelperPassword: '两次密码须一致，并至少 8 位且含大写字母、小写字母和数字',
    // P2 Trust indicators
    trustCloudflare: '由 Cloudflare Turnstile 提供防护',
    trustEmailReq: '需要邮件验证',
    trustEncryptedConfigs: '配置加密',
    trustSecureAuth: '安全认证',
    errorResetLinkExpired: '重置链接已过期或无效。请重新请求。',
    recoveryTakingLong: '安全验证所需时间比预期更长。页面仍在等待真实结果，尚未将此链接判定为失败。',
    cancelRecovery: '取消并重新获取链接',
  },

  // Legal pages
  legal: {
    termsTitle: '服务条款',
    privacyTitle: '隐私政策',
    termsLastUpdated: '最后更新：2026 年 7 月',
    privacyLastUpdated: '最后更新：2026 年 7 月',
    backToSignUp: '返回创建账户',
    backToHome: '返回首页',
    disclaimer: '本页面用于透明说明，并不构成专业法律意见。',
    importantNotice: '如对本文档有疑问，或需要查询、更正或删除账户数据，请通过 AlphaLab 项目的官方支持渠道联系。',
  },

  // Auth confirmed page
  authConfirmed: {
    eyebrow: '邮箱验证 / 状态',
    verifying: '正在验证你的确认链接…',
    title: '邮箱已确认',
    subtitle: '你的账户已激活。',
    description: '现在可以登录并配置交易连接。',
    descriptionWithSession: '邮箱已确认，你也已安全登录。请继续进入工作区。',
    verificationTakingLong: '安全验证所需时间比预期更长。我们仍在等待真实结果，尚未将此链接判定为失败。',
    cancelVerification: '取消并前往登录',
    invalidTitle: '确认链接无效',
    invalidDescription: '请使用收件箱中最新的确认链接，或返回创建账号页面重新发送邮件。',
    expiredTitle: '确认链接已过期',
    expiredDescription: '为保护账户安全，确认链接有有效期。请返回创建账号页面并重新发送邮件。',
    networkTitle: '暂时无法验证链接',
    networkDescription: '验证服务暂时不可用。请检查网络连接后再次打开邮件中的链接。',
    returnToSignUp: '返回创建账号',
    continueToSignIn: '前往登录',
    backToHome: '返回首页',
  },
  notFound: {
    title: '404',
    subtitle: '页面未找到',
    description: '这个页面不存在或已被移动。',
    backToHome: '返回首页',
    signIn: '前往登录',
  },

  // P3 — System Status Indicator
  systemStatus: {
    online: '运行正常',
    unavailable: '暂不可用',
    checking: '检查中...',
    lastChecked: '上次检查',
    apiHealthy: '系统正常',
    unavailableDesc: '状态检查失败——API 可能不可达',
  },

  // P3 — FAQ / Trust section
  faq: {
    title: '常见问题',
    subtitle: '关于 AlphaLab 平台与安全实践的常见问题。',
    q1: 'AlphaLab 是否提供财务或投资建议？',
    a1: '不提供。AlphaLab 是一个研究、教育和决策支持平台。平台提供市场数据、模型辅助分析和回测工具。所有交易决策和执行仍由你负责，我们不保证结果，也不提供个性化投资建议。',
    q2: '我的 API 密钥如何保护？',
    a2: 'API 密钥在写入数据库前会加密，并在界面中遮盖。已配置的集成只在后端获取其所需凭据。使用生产凭据前，请检查部署配置和日志策略。',
    q3: '模拟交易和实盘交易有什么区别？',
    a3: '模拟交易使用实时市场数据以虚拟资金模拟交易 — 无真实资金风险。实盘交易连接到您的券商账户并执行实际订单。您可以在设置中随时切换模式。模拟交易非常适合策略验证。',
    q4: '平台可以自动执行交易吗？',
    a4: '只有在你主动启用后才可以。人工订单仍需单独核对与确认；自动执行默认关闭，授权后也只能在你配置的券商、时间、路由和风控范围内运行，并且可以随时停用。',
    q5: 'AlphaLab 使用哪些数据提供商？',
    a5: 'AlphaLab 集成 Alpaca Markets（券商与交易）、Finnhub（市场数据）和 Supabase（身份验证与存储）。完成生产配置后，Cloudflare Turnstile 可用于保护身份验证表单。',
    q6: 'AlphaLab 是开源的吗？',
    a6: '项目仓库可在 GitHub 上查看和参与。重新分发或自行部署前，请先检查仓库中的许可与部署说明。',
  },

  // P3 — Product Demo Walkthrough
  walkthrough: {
    title: 'AlphaLab 工作流程',
    subtitle: '从市场扫描到风控执行 — 系统化量化工作流。',
    step1Title: '配置您的技术栈',
    step1Desc: '连接券商、AI 提供商和市场数据源。一站式统一配置。',
    step2Title: '扫描市场',
    step2Desc: '跨数千只股票执行多因子扫描。技术、动能和结构过滤器。',
    step3Title: 'AI 验证信号',
    step3Desc: '多模型 AI 审查候选标的。交叉验证结构、动能和周期共振。',
    step4Title: '生成入场计划',
    step4Desc: '根据您的风控规则自动生成入场价、止损位、目标价和仓位规模。',
    step5Title: '审核并执行',
    step5Desc: '先使用模拟交易；人工订单提交前需要核对。可选自动化只有在你授权后才会开启，并始终受已配置的风控约束。',
  },

  // P3 — Security Center (public page)
  security: {
    title: '安全与信任',
    subtitle: '我们如何保护您的数据并维护平台完整性。',
    featureAuth: '身份验证保护',
    featureAuthDesc: '所有敏感路由需要身份验证。会话管理使用 Supabase Auth。生产部署应验证令牌存储和传输设置。',
    featureEmail: '邮件验证',
    featureEmailDesc: '新账户需要邮件确认后才能使用平台功能，有助于确保账户所有权。',
    featureTurnstile: 'CAPTCHA 保护',
    featureTurnstileDesc: '生产环境配置站点密钥后，登录、注册和密码恢复表单会使用 Cloudflare Turnstile。每次部署后都应验证组件与策略是否生效。',
    featureCsp: '部署安全头',
    featureCspDesc: '前端构建支持安全响应头，包括 X-Content-Type-Options、Referrer-Policy 和 X-Frame-Options。生产部署应验证头部配置。',
    featureEncryption: '凭证存储',
    featureEncryptionDesc: '提供商密钥由后端配置处理，在界面中遮盖，也不会出现在常规读取响应中。生产部署需要核对加密配置。',
    featureRateLimit: '速率限制',
    featureRateLimitDesc: '后端设计支持在认证和 API 端点上进行速率限制。生产部署应根据环境配置适当的限制。',
    featureAudit: '审计追踪',
    featureAuditDesc: '关键用户操作和配置更改设计为可记录，以确保透明度和可追溯性。',
    featureHeaders: '传输安全',
    featureHeadersDesc: '部署安全响应头（X-Content-Type-Options、Referrer-Policy、X-Frame-Options）已包含在前端构建配置中。每次生产部署后请验证头部是否存在。',

    // What we never do / Security FAQ
    neverTitle: '常见的控制与安全问题',
    neverSubtitle: '以下说明订单何时可以执行、凭证如何处理，以及如何撤销访问权限。',
    never1: 'AlphaLab 可以自动提交订单吗？',
    never1Desc: '人工订单提交前需要明确核对与确认。自动执行默认关闭；只有在你主动启用后，才可在你配置的券商、时间、路由与风控范围内运行。你可以随时停用自动化或从券商端撤销访问权限。',
    never2: '我的 API 密钥安全吗？',
    never2Desc: 'API 密钥在界面中遮盖，也不会出现在常规读取响应中。请核对实际部署的加密配置，并随时删除或轮换凭证。',
    never3: '我可以先使用模拟盘吗？',
    never3Desc: '可以。AlphaLab 默认使用模拟盘工作流。你可以先在模拟环境中测试策略，再决定是否连接实盘券商账户。',
    never4: '我该如何撤销访问权限？',
    never4Desc: '你可以随时删除已保存的 API 密钥，并从券商或 AI 提供商后台撤销访问权限。',

    ctaTitle: '连接账户前，先检查控制边界。',
    ctaDesc: '从模拟模式开始，确保凭证可以撤销，并在实际部署环境中核对各项安全配置。',
  },

  // 平台
  platform: {
    heroTitle: '先研究，再执行',
    heroSubtitle: '在一个工作区内完成美股扫描、候选审核、历史测试和风险计划。',
    intelTitle: '候选标的如何变成可审核计划',
    intelSubtitle: '四个连续模块依次缩小范围、检查证据、测试想法并定义风险，然后才进入订单审核。',
    phase1: '阶段 1',
    scanTitle: '市场扫描',
    scanDesc: '对选定的股票范围应用流动性、价格、动能和结构条件，生成一份较小的待审核列表。',
    phase2: '阶段 2',
    aiTitle: '证据复核',
    aiDesc: '已配置的模型会对图表和市场背景提供第二意见。规则检查与历史测试仍然独立进行。',
    phase3: '阶段 3',
    planTitle: '风险计划',
    planDesc: '根据已选账户与风险限制，计算入场区间、保护性退出、目标价和仓位规模。',
    riskAware: '风险感知决策支持',
    beyondBlind: '先看证据，再做决定。',
    beyondBlindDesc: '每个候选标的都会保留筛选结果、模型复核、历史测试和风险计划，方便统一检查。',
    check1: '将已配置的模型提供商用作第二层复核。',
    check2: '模拟交易优先。人工订单需要核对；可选自动化默认关闭，并受你配置的风控范围约束。',
    check3: '输入、决定与淘汰原因会保留在同一研究记录中。',
    hubTitle: '交易逻辑中枢',
    hubPaper: '模拟交易：无需实盘资金测试策略。',
    hubLive: '实盘执行：直接连接券商。',
    hubAI: 'AI 供应商：配置 OpenAI、DeepSeek 或 Claude。',
    hubNote: '* 用户提供自己的 API 密钥；密钥配置采用加密安全处理。',
    whoTitle: 'AlphaLab 适合谁？',
    whoSubtitle: '专为看重流程与精度，而非“直觉”和盲目提醒的交易者设计。',
    traderTitle: '系统化交易者',
    traderDesc: '拥有明确规则，并希望通过自动化与 AI 辅助过滤来扩展执行能力的交易者。',
    quantTitle: '量化分析师',
    quantDesc: '希望将现代 LLM 推理整合到传统量化筛选流程中，而无需从零开始编写代码的分析师。',
    scalerTitle: '活跃多策略交易者',
    scalerDesc: '同时管理多个交易设置，需要确定性风险控制和仓位管理以保护本金的交易者。',
    readyTitle: '打开一个研究工作区',
    readyDesc: '先使用模拟模式，再连接你所需的数据源，并在执行前审核每个阶段。',
    getStarted: '创建账户',
  },

  // 工作流
  workflow: {
    heroTitle: '端到端的 <span style="background: linear-gradient(90deg, #60a5fa, #3b82f6); -webkit-background-clip: text; -webkit-text-fill-color: transparent;">量化工作流</span>',
    heroSubtitle: '六个阶段把广泛扫描转成一份可复核计划。每一步都会记录输入、产物，以及通过、保留或淘汰的原因。',
    sectionTitle: '从扫描到订单复核',
    sectionSubtitle: '选择一个阶段，查看它的目的、数据输入、产物和风险检查。',
    step1Title: '市场扫描器',
    step1Status: '全局扫描',
    step1Desc: '把所选筛选条件应用到已配置的股票范围。',
    step1Purpose: '根据工作区可用的标的与数据源，生成一份便于继续检查的初始列表。',
    step1Inputs: '已配置的价格、成交量、流动性和市场结构字段。',
    step1Outputs: '符合初始价格、流动性和波动率规则的标的。',
    step1Risk: '缺少数据或流动性不足的标的不会进入下一阶段。',
    step2Title: '候选跟踪',
    step2Status: '监控中',
    step2Desc: '使用同一套已记录规则持续更新候选。',
    step2Purpose: '在新 K 线到达后更新候选证据，不把单次波动直接视为确认。',
    step2Inputs: '时间序列价格、成交量和已记录的结构位置。',
    step2Outputs: '可以进入下一轮已配置筛选的候选。',
    step2Risk: '确认规则与过期数据检查会保留在记录中。',
    step3Title: '深度筛选',
    step3Status: '细化',
    step3Desc: '应用范围更窄的因子与结构规则。',
    step3Purpose: '按本次运行选择的时间周期和因子比较候选标的。',
    step3Inputs: '已配置的时间周期、波动率指标和因子值。',
    step3Outputs: '进入上下文复核和历史测试的小型候选列表。',
    step3Risk: '涨跌过度和结构规则失败会记录为淘汰原因。',
    step4Title: '深度验证',
    step4Status: '上下文复核',
    step4Desc: '把已配置模型作为独立的复核层。',
    step4Purpose: '检查现有市场背景与反证，但不替代规则检查或历史测试。',
    step4Inputs: '技术证据，以及已配置的新闻或板块背景。',
    step4Outputs: '包含引用证据、局限和未解决问题的复核说明。',
    step4Risk: '模型分歧和来源缺失会保留给用户复核。',
    step5Title: '入场计划',
    step5Status: '计划中',
    step5Desc: '根据所选限制计算价位与仓位。',
    step5Purpose: '把研究记录转成入场、保护性退出、目标价和仓位建议。',
    step5Inputs: '波动率指标、账户价值和已配置风险限制。',
    step5Outputs: '一份等待用户复核的边界明确计划。',
    step5Risk: '仓位建议不能超过账户和计划中保存的限制。',
    step6Title: '复核与执行',
    step6Status: '审批',
    step6Desc: '在模拟或实盘路由前检查计划。',
    step6Purpose: '继续监控计划、提交到模拟盘，或在批准后路由到已配置的实盘券商。',
    step6Inputs: '已批准计划、所选环境和可用券商连接。',
    step6Outputs: '订单记录，或一条明确的不提交决定。',
    step6Risk: '提交前检查目标环境、购买力和订单明细。',
    coreWorkflow: '核心工作流',
    phaseLabel: '阶段',
    purposeLabel: '目的',
    inputsLabel: '输入',
    outputsLabel: '输出',
    riskCheckLabel: '风险检查',
    readyTitle: '用自己的规则检查这套流程。',
    getStarted: '创建账户',
  },

  // 特性
  features: {
    heroTitle: '平台功能',
    heroSubtitle: '筛选市场、复核背景、检验假设、定义风险，再决定一份计划是否继续推进。',
    disclaimer: '仅用于研究与决策辅助，不构成投资建议。',
    group1Title: '1. 市场扫描',
    group1Desc: '扫描数千只股票，并保留符合所选规则的候选。',
    f1_1Title: '实时扫描器',
    f1_1Desc: '通过多因子技术筛选，识别数千只股票中的新兴趋势和异常情况。',
    f1_2Title: '精细过滤器',
    f1_2Desc: '使用精细化筛选逻辑，识别底部突破、均值回归等早期多周期结构。',
    f1_3Title: '智能自选列表',
    f1_3Desc: '通过实时战术警报和持续的技术评分跟踪来监控候选标的。',
    group2Title: '2. AI 验证',
    group2Desc: '把已配置模型作为复核上下文和反证的第二层检查。',
    f2_1Title: 'LLM 上下文审计',
    f2_1Desc: '部署专用的 AI 模型来审计市场结构背景和情绪，消除技术性假阳性。',
    f2_2Title: '多供应商路由',
    f2_2Desc: '架构不依赖单一提供商，兼容 OpenAI、DeepSeek、Claude 和本地 LLM。',
    f2_3Title: '自主验证',
    f2_3Desc: '自主智能，在您看到结果之前协调整个研究和验证工作流。',
    group3Title: '3. 回测与优化',
    group3Desc: '在承担资金风险前，基于历史数据验证假设。',
    f3_1Title: '机构级回测',
    f3_1Desc: '使用细粒度的性能指标和回撤分析，基于历史 Tick 数据验证假设。',
    f3_2Title: '参数优化',
    f3_2Desc: '利用量化算法调整策略参数，提升超额收益潜力，同时控制风险。',
    f3_3Title: '策略对比',
    f3_3Desc: '并排对比多个量化模型的性能，以识别最稳健的交易设置。',
    group4Title: '4. 入场计划与风控',
    group4Desc: '在你配置的限制内，计算建议入场、退出和仓位。',
    f4_1Title: '确定性入场',
    f4_1Desc: '确定性地生成入场区域、追踪止损和止盈目标。',
    f4_2Title: '仓位管理',
    f4_2Desc: '感知账户资产规模，确保您每笔交易的风险永远不超过权益的 1%。',
    f4_3Title: '风险治理',
    f4_3Desc: '硬编码的风险协议，防止过度暴露，并在每个计划上执行严格的风险回报阈值。',
    group5Title: '5. 执行工作流',
    group5Desc: '默认从模拟模式开始，实盘路由前需要明确复核。',
    f5_1Title: '模拟交易',
    f5_1Desc: '在模拟环境中测试新策略和 AI 配置，无需承担实盘资金风险。',
    f5_2Title: '实盘券商集成',
    f5_2Desc: '通过高性能券商 API 连接（如 Alpaca）直接执行。',
    f5_3Title: '执行监控',
    f5_3Desc: '实时跟踪成交、滑点和追踪止损调整。',
    readyTitle: '从一个研究问题开始。',
    readyDesc: '先在模拟模式中检查证据、局限和风险计划，再考虑执行。',
    getStarted: '创建账户',
  },

  // Technology
  technology: {
    heroTitle: '技术与架构',
    heroSubtitle: '工作区将数据接入、模型复核、量化测试、风险计划和券商路由分开，让每项职责都能单独检查。',
    archTitle: '系统架构',
    archMarketFeeds: '行情数据源',
    archAIValidation: 'AI 验证核心',
    archBrokerAPI: '券商 API',
    archDesc: '数据采集、模型复核、量化检查和订单路由分别运行，并通过明确的记录交接。',
    stackFrontendTitle: '前端：React & TypeScript',
    stackFrontendDesc: 'React 与 TypeScript 用于呈现研究工作区、响应式布局、表格、图表和表单。',
    stackBackendTitle: '后端：Python & Flask',
    stackBackendDesc: 'Python 与 Flask 提供市场数据、研究运行、设置和交易集成所需的认证接口。',
    stackDataTitle: '行情数据中心',
    stackDataDesc: '已配置的 Alpaca 与 Finnhub 连接提供工作区使用的行情、公司和板块数据。',
    stackAlpacaTitle: 'Alpaca 连接',
    stackAlpacaDesc: '通过券商 API 直接对接 Alpaca Markets，支持模拟交易和实盘执行路由。',
    stackLLMTitle: '多 LLM 流水线',
    stackLLMDesc: '提供商适配器让已配置模型复核上下文与反证，但不负责确定性门槛。',
    stackQuantTitle: '量化核心引擎',
    stackQuantDesc: '回测与策略比较会记录表现、成本、回撤和测试假设。',
    stackValidationTitle: '验证流水线',
    stackValidationDesc: '阶段检查把筛选规则、模型说明、测试结果和淘汰原因保留在同一份研究记录中。',
    stackRiskTitle: '基于账户权益的仓位管理',
    stackRiskDesc: '仓位建议使用所选账户和已配置的单笔风险限制。',
    stackSecretsTitle: '安全的密钥管理',
    stackSecretsDesc: '用户在设置中填写提供商凭证。保存后界面只显示遮罩值，并可在提供商后台轮换。',
    stackDockerTitle: 'Docker 编排',
    stackDockerDesc: '容器定义打包前端、接口和部署配置，方便重复搭建环境。',
    catClient: '客户端',
    catServer: '服务器',
    catData: '数据层',
    catExecution: '执行',
    catIntelligence: '智能',
    catQuant: '量化',
    catLogic: '逻辑',
    catRisk: '风控',
    catSecurity: '安全',
    catDevOps: 'DevOps',
    ctaTitle: '从数据到决策，逐层检查系统。',
    ctaAction: '创建账户',
  },
};

export default messages;
